// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 6%27%3E%3Cpath fill=%27%23666%27 d=%27M0 0l5 6 5-6z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

:root {
    --ce-offwhite-base: #fdfdfe;
    --ce-grey-1-base: #FBFCFC;
    --ce-grey-2-base: #f8f9fb;
    --ce-grey-3-base: #F4F6F7;
    --ce-grey-4-base: #F1F2F5;
    --ce-grey-5-base: #EDEFF2;
    --ce-grey-10-base: #DFE1E7;
    --ce-grey-20-base: #C6CAD5;
    --ce-grey-30-base: #A9ADBF;
    --ce-grey-40-base: #8E90A6;
    --ce-grey-50-base: #73748B;
    --ce-grey-55-base: #6B6B81;
    --ce-grey-60-base: #595A6B;
    --ce-grey-70-base: #434351;
    --ce-grey-80-base: #2E2D35;
    --ce-grey-90-base: #1D1C21;
    --ce-grey-95-base: rgb(27, 26, 31);
    --ce-grey-96-base: rgb(25, 25, 29);
    --ce-grey-97-base: rgb(22, 21, 25);
    --ce-grey-98-base: rgb(20, 19, 23);
    --ce-grey-99-base: rgb(17, 16, 19);

    --ce-blue-muted-1-base: #f9fcfd;
    --ce-blue-muted-2-base: #f6fafd;
    --ce-blue-muted-3-base: #f0f7fb;
    --ce-blue-muted-4-base: #eaf3fa;
    --ce-blue-muted-5-base: #e4f0f8;
    --ce-blue-muted-10-base: #cee4f4;
    --ce-blue-muted-20-base: #a8cfec;
    --ce-blue-muted-30-base: #75b4e1;
    --ce-blue-muted-40-base: #4698d3;
    --ce-blue-muted-50-base: #187ac1;
    --ce-blue-muted-55-base: #0b70ba;
    --ce-blue-muted-60-base: #005da6;
    --ce-blue-muted-70-base: #004483;
    --ce-blue-muted-80-base: #002e5b;
    --ce-blue-muted-90-base: #001d3b;

    --ce-red-2: #FEF5F5;
    --ce-red-3: #FDF3F4;
    --ce-red-4: #FDEFF0;
    --ce-red-5: #FCEAEA;
    --ce-red-10: #F9D9DA;
    --ce-red-20: #F4BBBD;
    --ce-red-muted-55-base: #CE2C32;
    --ce-red-muted-70-base: #8F0005;

    --ce-green-1: #F8FDFB;
    --ce-green-2: #F1FBF6;
    --ce-green-3: #EAF9F2;
    --ce-green-5: #DBF4E9;
    --ce-green-10: #BDEAD7;
    --ce-green-20: #8AD9B8;
    --ce-green-30: #45C28F;
    --ce-green-40: #23A482;
    --ce-green-55: #007B6C;
    --ce-green-70: #004E45;

    --ce-violet-5: #F9E9FF;
    --ce-violet-10: #F4D6FF;
    --ce-violet-40: #CF5EFF;
    --ce-violet-55: #A22AE9;

    --ce-indigo-1: rgb(251, 252, 255);
    --ce-indigo-2: rgb(247, 248, 255);
    --ce-indigo-3: rgb(244, 245, 255);
    --ce-indigo-4: rgb(241, 241, 255);
    --ce-indigo-5: #EDEDFF;
    --ce-indigo-10: #DEDDFF;
    --ce-indigo-20: rgb(200, 196, 253);
    --ce-indigo-30: rgb(172, 163, 250);
    --ce-indigo-40: #8F82F6;
    --ce-indigo-55: #6653F0;
    --ce-indigo-60: rgb(83, 61, 224);
    --ce-indigo-70: rgb(54, 28, 201);
    --ce-indigo-80: rgb(36, 16, 142);
    --ce-indigo-90: rgb(22, 8, 98);

    --ce-yellow-1: #FFFCE6;
    --ce-yellow-2: #FFF9CF;
    --ce-yellow-3: #FFF7C3;
    --ce-yellow-5: #FFF094;
    --ce-yellow-10: #FFE02B;
    --ce-orange-1: #FFFBF6;
    --ce-orange-4: #FFF1E3;
    --ce-orange-10: #FFDBB8;
    --ce-orange-40: #EC6C05;
    --ce-orange-55: #B15103;

    --ce-offwhite: var(--ce-offwhite-base);
    --ce-grey-1: var(--ce-grey-1-base);
    --ce-grey-2: var(--ce-grey-2-base);
    --ce-grey-3: var(--ce-grey-3-base);
    --ce-grey-4: var(--ce-grey-4-base);
    --ce-grey-5: var(--ce-grey-5-base);
    --ce-grey-10: var(--ce-grey-10-base);
    --ce-grey-20: var(--ce-grey-20-base);
    --ce-grey-30: var(--ce-grey-30-base);
    --ce-grey-40: var(--ce-grey-40-base);
    --ce-grey-50: var(--ce-grey-50-base);
    --ce-grey-55: var(--ce-grey-55-base);
    --ce-grey-60: var(--ce-grey-60-base);
    --ce-grey-70: var(--ce-grey-70-base);
    --ce-grey-80: var(--ce-grey-80-base);
    --ce-grey-90: var(--ce-grey-90-base);
    --ce-grey-95: var(--ce-grey-95-base);
    --ce-grey-96: var(--ce-grey-96-base);
    --ce-grey-97: var(--ce-grey-97-base);
    --ce-grey-98: var(--ce-grey-98-base);
    --ce-grey-99: var(--ce-grey-99-base);
    --ce-blue-muted-1: var(--ce-blue-muted-1-base);
    --ce-blue-muted-2: var(--ce-blue-muted-2-base);
    --ce-blue-muted-3: var(--ce-blue-muted-3-base);
    --ce-blue-muted-4: var(--ce-blue-muted-4-base);
    --ce-blue-muted-5: var(--ce-blue-muted-5-base);
    --ce-blue-muted-10: var(--ce-blue-muted-10-base);
    --ce-blue-muted-20: var(--ce-blue-muted-20-base);
    --ce-blue-muted-30: var(--ce-blue-muted-30-base);
    --ce-blue-muted-40: var(--ce-blue-muted-40-base);
    --ce-blue-muted-50: var(--ce-blue-muted-50-base);
    --ce-blue-muted-55: var(--ce-blue-muted-55-base);
    --ce-blue-muted-60: var(--ce-blue-muted-60-base);
    --ce-blue-muted-70: var(--ce-blue-muted-70-base);
    --ce-blue-muted-80: var(--ce-blue-muted-80-base);
    --ce-blue-muted-90: var(--ce-blue-muted-90-base);
    --ce-red-muted-55: var(--ce-red-muted-55-base);
    --ce-red-muted-70: var(--ce-red-muted-70-base);
    --ce-red-55: var(--ce-red-muted-55);
    --ce-red-40: #E66B6F;
    --ce-red-60: #AE252A;
    --ce-green-60: #00675B;
    --ce-orange-60: #954403;
}

:root {
    /* nicknames */
    --white-filter: brightness(0) saturate(100%) invert(100%) sepia(1%) saturate(0%) hue-rotate(175deg) brightness(103%) contrast(101%);
    --blue: var(--ce-blue-muted-55);
    --blue-filter: brightness(0) saturate(100%) invert(28%) sepia(100%) saturate(994%) hue-rotate(180deg) brightness(98%) contrast(96%);
    --blue-hover: var(--ce-blue-muted-70);
    --blue-hover-filter: brightness(0) saturate(100%) invert(17%) sepia(46%) saturate(3767%) hue-rotate(192deg) brightness(94%) contrast(103%);
    --highlight-blue: var(--ce-blue-muted-3);
    --blue-bg: var(--ce-blue-muted-2);
    --blue-border: var(--ce-blue-muted-10);
    --red: var(--ce-red-muted-55);
    --red-hover: var(--ce-red-muted-70);
    --red-bg: var(--ce-red-2);
    --red-border: var(--ce-red-10);
    --green: var(--ce-green-55);
    --green-hover: var(--ce-green-70);
    --green-bg: var(--ce-green-2);
    --green-border: var(--ce-green-10);

    /* intent-based blues */
    --primary: var(--blue);
    --primary-hover: var(--blue-hover);
    --highlight-border: var(--ce-blue-muted-20);
    --warning: var(--ce-orange-40);
    --warning-filter: brightness(0) saturate(100%) invert(58%) sepia(79%) saturate(3101%) hue-rotate(353deg) brightness(89%) contrast(109%);
    --warning-hover: #ec4a05;

    /* intent-based greys */
    --background-white: var(--ce-offwhite);
    --background: var(--ce-grey-1);
    --background-2: var(--ce-grey-2);
    --background-headers: var(--ce-grey-4);
    --selected: var(--ce-grey-4);
    --background-5: var(--ce-grey-5);
    --icon-grey: var(--ce-grey-40);
    --icon-grey-hover: var(--ce-grey-60);
    --icon-grey-filter: brightness(0) saturate(100%) invert(61%) sepia(7%) saturate(776%) hue-rotate(197deg) brightness(93%) contrast(89%);
    --icon-grey-hover-filter: brightness(0) saturate(100%) invert(51%) sepia(83%) saturate(128%) hue-rotate(199deg) brightness(51%) contrast(74%);
    --default_text_color: var(--ce-grey-80);
    --lightest_legible_grey: var(--ce-grey-55);
    --lightest-legible-grey-filter: invert(46%) sepia(9%) saturate(840%) hue-rotate(201deg) brightness(89%) contrast(87%);
    --lightest_legible_grey_against_white: var(--ce-grey-50);
    --lightest_legible_grey_large_text: var(--ce-grey-40);

    /* gradients */
    --ce-com-gradient: linear-gradient(180deg, #E7E6F9 0%, #F3DFDB 100%);
    
    /* other vars */
    --highlight_green: #28a745;
    --red-text: var(--ce-red-muted-55);
    --border_color: var(--ce-grey-10);
    --border: 1px solid var(--border_color);
    --border_radius: 5px;
    --border_radius_cards: 10px;
    --border_radius_lg: 20px;
    --box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
    --box-shadow-2: 0 3px 12px rgba(0, 0, 0, 0.15);
    --transition: all .1s;
    --min-target-size: 30px;
    --min_desktop_target: 30px;
    --min_touch_target: 36px;
    --min_nav_target: 40px;
    --ideal_touch_target: 44px;
    --nav_height: 41px;
    --target_spacing: 3px;
    --button_gap: 4px;
    --lg_padding: 20px;
    --md_padding: 10px;
    --sm_padding: 5px;
    --btn_padding: 8px;
    --btn_icon_padding: 2px;
    --tab_active: 3px solid var(--blue);
    --tab_active_secondary: 3px solid var(--ce-grey-60);
    --tab_inactive: 3px solid transparent;
    --error_background: #ffeeee;
    --error_color: #973b37;
    --success_background: #f5ffee;
    --success_color: #3e6c46;

    /* typography */
    --default_line_height: 1.4;
    --text_sm: 12px;
    --text_md: 16px;
    --text_lg: 20px;
    --header-title-size: 20px;
    --font-size-default-desktop: 14px;
    --line-height: 1.3;
    --p-margin: 0.75em;
    --ul-margin: 1.5em;

    /* Apply CE Design system colors to toastify */
    --toastify-color-success: rgb(17, 157, 73);
    --toastify-color-warning: rgb(214, 114, 0);
    --toastify-color-error: rgb(239, 55, 36);
    --toastify-color-info: rgb(0, 127, 249);
}

@media screen and (max-width: 768px) {
    :root {
        --min-target-size: 36px;
    }
}

[data-ce-theme='dark'] {
    --ce-grey-1: var(--ce-grey-99-base);
    --ce-grey-2: var(--ce-grey-98-base);
    --ce-grey-3: var(--ce-grey-97-base);
    --ce-grey-4: var(--ce-grey-96-base);
    --ce-grey-5: var(--ce-grey-95-base);
    --ce-grey-10: var(--ce-grey-90-base);
    --ce-grey-20: var(--ce-grey-80-base);
    --ce-grey-30: var(--ce-grey-70-base);
    --ce-grey-40: var(--ce-grey-60-base);
    --ce-grey-50: var(--ce-grey-55-base);
    --ce-grey-55: var(--ce-grey-50-base);
    --ce-grey-60: var(--ce-grey-40-base);
    --ce-grey-70: var(--ce-grey-30-base);
    --ce-grey-80: var(--ce-grey-20-base);
    --ce-grey-90: var(--ce-grey-10-base);
    --ce-grey-95: var(--ce-grey-5-base);
    --ce-grey-96: var(--ce-grey-4-base);
    --ce-grey-97: var(--ce-grey-3-base);
    --ce-grey-98: var(--ce-grey-2-base);
    --ce-grey-99: var(--ce-grey-1-base);

    --border_color: var(--ce-grey-30);
    --border: 1px solid var(--ce-grey-30);
    --default_text_color: var(--ce-grey-80);
    --background-5: var(--ce-grey-5);
}

:root {
  /* ===================
      Design System - Color aliases for intent-based use cases
  =================== */
  --ce-intent-none: var(--background-2);
  --ce-intent-primary:  var(--blue);
  --ce-intent-secondary: var(--ce-grey-70);
  --ce-intent-success: var(--ce-green-55);
  --ce-intent-danger: var(--ce-red-55);
  --ce-intent-warning: var(--ce-orange-40);
  /* Color for things like text that appears on top of the intent-color */
  --ce-intent-none-contrast: var(--ce-grey-90);
  --ce-intent-primary-contrast: #fff;
  --ce-intent-secondary-contrast: var(--ce-grey-1);
  --ce-intent-success-contrast: var(--ce-grey-1);
  --ce-intent-danger-contrast: var(--ce-grey-1);
  --ce-intent-warning-contrast: var(--ce-grey-1);
  /* Color for a light/faded background based on the intent color.*/
  --ce-intent-none-faded: var(--background-5);
  --ce-intent-primary-faded: var(--blue-hover);
  --ce-intent-secondary-faded: var(--ce-grey-40);
  --ce-intent-success-faded: var(--ce-green-40);
  --ce-intent-danger-faded: var(--ce-red-40);
  --ce-intent-warning-faded: var(--ce-orange-40);
  /* Color for an outline or border when button is focused.*/
  --ce-intent-none-outline: var(--border_color);
  --ce-intent-primary-outline: var(--ce-blue-60);
  --ce-intent-secondary-outline: var(--ce-grey-70);
  --ce-intent-success-outline: var(--ce-green-60);
  --ce-intent-danger-outline: var(--ce-red-60);
  --ce-intent-warning-outline: var(--ce-orange-60);
}

html {
    box-sizing: border-box;
}

*,
*:before,
*:after {
    box-sizing: inherit;
}

.survey-step *,
.survey-step *:before,
.survey-step *:after {
    box-sizing: initial;
}

* {
    scrollbar-width: thin;
}

html,
body,
.rkstudio-layout {
    min-height: 100%;
    height: 100%;
    overflow: auto;
}

.rkstudio-layout {
    color: var(--default_text_color);
    background: var(--background-white);
}

/* typography */

.rk-admin .empty-state {
    color: var(--lightest_legible_grey);
    font-size: 24px;
    font-weight: 500;
}

/* nav */
nav a {
    display: flex;
    align-items: center;
    cursor: pointer;
}

nav a svg[data-prefix="fas"] {
    display: none;
}

nav a svg[data-prefix="far"] {
    display: flex;
}

nav a svg {
    width: 20px;
    justify-content: flex-start;
}

nav a.selected {
    color: #111;
    background: var(--selected);
    font-weight: bold;
    border-radius: 100px;
}

nav a:hover svg[data-prefix="fas"],
nav a.selected svg[data-prefix="fas"] {
    display: flex;
}

nav a:hover svg[data-prefix="far"],
nav a.selected svg[data-prefix="far"] {
    display: none;
}

nav a svg {
    margin-right: 7px;
}

nav a svg[class*="caret"][data-prefix="fas"],
nav a svg[class*="circle-plus"][data-prefix="fas"],
nav a svg[class*="circle-plus"][data-prefix="far"] {
    margin-right: 0;
    display: flex;
}

#current-panel {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.rkstudio-layout {
    font-size: 12px;
}

#support-form {
    display: none;
}

.support-center {
    padding: 20px;
}

a:link,
a:visited {
    color: var(--blue);
}

a:hover {
    color: var(--blue-hover);
    text-decoration: underline;
}

input,
select,
textarea {
    font-size: 12px;
}

#current-panel {
    padding: 0;
    margin: 0;
}

.clear {
    clear: both;
}

.page-container {
    position: fixed;
    height: 100%;
    top: calc(var(--min_nav_target) + 1px);
    width: 100%;
    z-index: 2;
    height: calc(100% - 40px);
    overflow: auto;
}

.rk-admin {
    font-size: 12px;
    position: relative;
    -webkit-font-smoothing: antialiased;
}

.rk-admin .clickable {
    cursor: pointer;
}

.rk-admin .draggable {
    cursor: move !important;
}

.rk-admin strong {
    font-weight: bold;
}

.rk-admin .intro-content {
    margin-left: 20px;
    margin-right: 20px;
    line-height: 20px;
    margin-top: 10px;
}

.rk-admin .admin-table {
    border: solid 1px #ddd;
    border-radius: 2px;
    margin-left: 20px;
    margin-right: 20px;
}

.rk-admin .admin-table table {
    line-height: 20px;
    width: 100%;
}

.rk-admin .admin-table th {
    text-transform: uppercase;
    font-size: 12px;
    color: #666;
    text-align: left;
    background: var(--background-2);
    padding: 10px;
    border-bottom: solid 1px #ddd;
}

.rk-admin .admin-table td {
    font-size: 12px;
    padding: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border-bottom: solid 1px #eee;
}

.rk-admin .admin-table tr.alternating {
    background: var(--background-2);
}

.rk-admin .admin-table tr:last-child td {
    border-bottom: none;
}

.rk-admin .admin-table.with-detail tr:hover {
    background: var(--selected);
    cursor: pointer;
}

.rk-admin .admin-table a {
    text-decoration: none;
}

.rk-admin .admin-table tr.edit-panel td {
    vertical-align: top;
    border-top: solid 1px #eee;
}


/* form elements */

.rk-admin .required {
    color: var(--red-text);
    font-weight: normal;
    font-style: italic;
    font-size: 13px;
}

.rk-admin .admin-input,
.rk-admin .admin-select,
.rk-admin .admin-textarea,
.rk-admin .image-upload,
.rk-admin .editor-controls-button {
    width: auto;
    min-height: var(--min_desktop_target);
    min-width: var(--min_desktop_target);
    margin-right: var(--target_spacing);
    border-radius: var(--border_radius);
    border-color: var(--border_color);
    border-style: solid;
    border-width: 1px;
    transition: var(--transition);
}

.rk-admin .admin-input::placeholder,
.rk-admin .admin-select::placeholder,
.rk-admin .admin-textarea::placeholder {
    color: var(--lightest_legible_grey);
}

.rk-admin .admin-input:hover,
.rk-admin .admin-select:hover,
.rk-admin .admin-textarea:hover {
    border: 1px solid var(--highlight-border);
}

.rk-admin .admin-input:hover:disabled,
.rk-admin .admin-input:hover[disabled="disabled"],
.rk-admin .admin-select:hover[disabled="disabled"],
.rk-admin .admin-textarea:hover[disabled="disabled"] {
    border-color: var(--border_color);
    cursor: default;
}


.rk-admin .admin-input:focus-visible,
.rk-admin .admin-select:focus-visible,
.rk-admin .admin-textarea:focus-visible {
    outline: 0;
    border: 1px solid var(--blue);
}

.rk-admin .admin-input {
    box-sizing: border-box;
    height: 30px;
    line-height: 24px;
    width: auto;
    padding-left: 10px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 2px;
    font-family: inherit;
    max-width: 100%;
}

.rk-admin .admin-input[type="checkbox"] {
    min-width: 16px !important;
    min-height: 16px !important;
    width: 16px !important;
    height: 16px !important;
}

.rk-admin .admin-input.large-input {
    min-width: 300px;
}

.rk-admin .admin-input.interval-input {
    width: 60px;
}

.rk-admin .admin-input.suppress-disabled-styles:disabled {
    background: none;
    border: none;
    color: #333;
    -webkit-text-fill-color: #333;
    opacity: 1;
    /* required on iOS */
}

.rk-admin .localized-input {
    width: calc(100% - 94px) !important;
}

.rk-admin .url-input {
    width: calc(100% - 115px) !important;
}

.rk-admin .locale-selector {
    width: 80px;
}

.rk-admin .admin-select {
    appearance: none;
    -webkit-appearance: none;
    transition: none;
    line-height: 24px;
    border-radius: var(--border_radius);
    padding: 2px 24px 2px 8px;
    border-color: #d9d9d9;
    background-color: #FFF;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 8px 5px;
    min-height: var(--min_desktop_target);
    height: var(--min_desktop_target);
    /* min-height not enough for safari */
    max-width: 100%;
    cursor: pointer;
    color: #000;
}

.rk-admin .admin-select.inline {
    width: auto !important;
    margin-bottom: 5px;
}


.rk-admin .admin-textarea {
    height: 30em;
    border-radius: var(--border_radius);
    width: 180px;
    padding-left: 10px;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-right: 5px;
    border: 1px solid #ccc;
    padding-right: 2px;
    border-color: #d9d9d9;
    font-family: inherit;
}

.rk-admin .admin-checkbox,
.rk-admin .admin-radio {
    margin-top: 9px;
    margin-bottom: 8px;
}

.checkbox-field {
    display: flex;
    align-items: center;
    column-gap: 4px;
}

.checkbox-field .admin-checkbox {
    margin-bottom: 9px;
}

.rk-admin .button {
    border-radius: var(--border_radius);
    padding: 0 10px;
    cursor: pointer;
    min-height: var(--min_desktop_target);
    min-width: var(--min_desktop_target);
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    line-height: 1.2;
    transition: var(--transition);
}

.rk-admin .button .back-arrow {
    padding-right: var(--md_padding);
    font-size: 17px;
}

.rk-admin .editor-controls-button {
    border: var(--border);
    cursor: pointer;
    border-radius: var(--border_radius);
    min-height: var(--min_desktop_target);
    padding: var(--target_spacing) var(--btn_padding);
    font-weight: normal;
    background: var(--background-2);
    color: var(--default_text_color);
    font-family: inherit;
    font-size: var(--text_sm);
    position: relative;
    justify-content: center;
    align-items: center;
}

.rk-admin .editor-controls-button>* {
    padding: 0 2px;
}

.rk-admin .editor-controls-button>.fa {
    padding: 0 var(--btn_icon_padding);
}

.rk-admin .combo-button-group,
.rk-admin .combo-input-group {
    display: flex;
    margin-left: 0;
    margin-right: var(--target_spacing);
}

.rk-admin .combo-button-group .editor-controls-button:first-of-type,
.rk-admin .combo-input-group .admin-input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: -1px;
    padding-right: 6px;
}

.rk-admin .combo-button-group .editor-controls-button:last-of-type,
.rk-admin .combo-input-group .editor-controls-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: var(--border);
}

.rk-admin .editor-controls-button:hover:enabled {
    background: var(--background-5);
}

.rk-admin .editor-controls-button.disabled,
.rk-admin .editor-controls-button.secondary-button.disabled,
.rk-admin .editor-controls-button:disabled,
.rk-admin .editor-controls-button.secondary-button:disabled,
.rk-admin .editor-controls-button.danger-button:disabled {
    cursor: auto;
    color: var(--ce-grey-30);
    background: var(--background-2);
    border: 1px solid var(--ce-grey-5);
    cursor: auto;
}

.rk-admin .editor-controls-button.open {
    background: #fff;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.rk-admin .editor-controls-button.secondary-button,
.rk-admin .editor-controls-button.outline-button {
    color: var(--primary);
    border: 1px solid var(--primary);
    background: #fff;
}

.rk-admin .editor-controls-button.minimal-button,
.rk-admin .editor-controls-button.minimal-button:hover:enabled,
.rk-admin .editor-controls-button.minimal-button:disabled {
    border: none;
    background: transparent;
}

.rk-admin .editor-controls-button.secondary-button:hover:enabled,
.rk-admin .editor-controls-button.outline-button:hover:enabled {
    color: var(--primary-hover);
    border: 1px solid var(--primary-hover);
    background: var(--highlight-blue);
}

.rk-admin .editor-controls-button.primary-button {
    background: var(--primary);
    border: 1px solid var(--primary);
    color: #FFF;
}

.rk-admin .editor-controls-button.primary-button:disabled,
.rk-admin .editor-controls-button.confirm-button:disabled {
    cursor: not-allowed;
    opacity: .6;
}

.rk-admin .editor-controls-button.primary-button:hover:enabled {
    background: var(--primary-hover);
    border: 1px solid var(--primary-hover);
    color: #fff;
}

.rk-admin .editor-controls-button.indigo-button {
    background: linear-gradient(135deg, var(--ce-indigo-55) 0%, var(--ce-indigo-40) 100%);
    border: 1px solid transparent;
    color: #fff;
    box-shadow: 0 2px 8px rgba(102, 83, 240, 0.25);
}

.rk-admin .editor-controls-button.indigo-button:hover:enabled {
    background: linear-gradient(135deg, #5847D8 0%, var(--ce-indigo-55) 100%);
    border-color: transparent;
    color: #fff;
    box-shadow: 0 4px 14px rgba(102, 83, 240, 0.35);
}

.rk-admin .editor-controls-button.indigo-button:disabled {
    cursor: not-allowed;
    opacity: .6;
}

.rk-admin .editor-controls-button.add-button,
.rk-admin .editor-controls-button.save-button {
    background: var(--primary);
    border: 1px solid var(--primary);
    color: #FFF;
}

.rk-admin .editor-controls-button.add-button:hover:enabled,
.rk-admin .editor-controls-button.save-button:hover:enabled {
    background: var(--primary-hover);
    border: 1px solid var(--primary-hover);
}

.rk-admin .editor-controls-button.confirm-button {
    color: #fff;
    border: 1px solid var(--primary);
    background: var(--primary);
}

.rk-admin .editor-controls-button.confirm-button:hover:enabled {
    color: #fff;
    border: 1px solid var(--primary-hover);
    background: var(--primary-hover);
}

.rk-admin .editor-controls-button.danger-button {
    background: var(--red);
    color: #FFF;
}

.rk-admin .editor-controls-button.danger-button:hover:enabled {
    background: var(--red-hover);
}

.rk-admin .tertiary-button {
    color: var(--blue);
    background: #fff;
    border: 1px solid var(--blue);
}

.rk-admin .admin-header {
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    display: table;
    width: calc(100% - 44px);
}

.rk-admin .items-list {
    border: solid 1px #ddd;
    border-radius: 2px;
    margin: 10px 0;
}

.rk-admin .items-list .items-list-item {
    border-top: solid 1px #ddd;
    padding: 10px;
    position: relative;
    line-height: 1.3;
    cursor: pointer;
    min-height: 30px;
}

.rk-admin .items-list .items-list-item .items-list-item-content,
.rk-admin .items-list .items-list-item .left-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.rk-admin .items-list .items-list-item .items-list-item-content.associated-projects {
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
}

.rk-admin .items-list .items-list-item .fa-users,
.rk-admin .items-list .items-list-item .fa-link {
    font-size: 14px;
    color: #28a745;
    padding-right: 10px;
}

.rk-admin .items-list .items-list-item .item-name {
    font-size: 16px;
    word-break: break-word;
}

.rk-admin .items-list .items-list-item .item-description {
    color: #666;
    word-break: break-word;
}

.rk-admin .items-list .items-list-item .item-buttons {
    top: 5px;
    right: 10px;
    display: flex;
    justify-content: flex-end;
}

.rk-admin .items-list .items-list-item .item-buttons button {
    margin: 2px;
    display: flex;
}

.rk-admin .items-list .items-list-item:first-child {
    border-top: none;
}

.rk-admin .items-list .items-list-item:hover {
    background-color: var(--background-2);
}

.rk-admin .items-list .items-list-item:hover .item-name {
    color: var(--blue);
}

.rk-admin .items-list .items-list-item.synced-with-redcap:hover .item-name {
    color: inherit;
}

.rk-admin .control-bar,
.rk-admin .search-bar {
    padding: var(--md_padding) calc(var(--lg_padding) - var(--target_spacing)) var(--md_padding) var(--lg_padding);
    border-bottom: var(--border);
    position: relative;
    z-index: 2;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.rk-admin .control-bar .control-bar-left {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    max-width: 100%;
}

.rk-admin .control-bar .control-bar-right {
    float: right;
}

.rk-admin .selected-item-messages {
    position: absolute;
    right: 20px;
    top: 10px;
}

.rk-admin .form-field {
    position: relative;
    border-bottom: solid 1px #eee;
    padding-left: 180px;
    padding-right: 38px;
    padding-bottom: 10px;
    padding-top: 10px;
    min-height: 30px;
}

.rk-admin .form-field:last-of-type {
    border-bottom: none;
}

.rk-admin .form-field>label .fa,
.rk-admin .form-field>label i {
    color: #bababa;
}

.rk-admin .form-field>label .fa:hover,
.rk-admin .form-field>label i:hover {
    color: #666;
}


.rk-admin .form-field.long-label {
    padding-left: 260px;
}

.rk-admin .form-field .form-field-input .admin-input,
.rk-admin .form-field .form-field-input .admin-textarea {
    width: 100%;
}

.rk-admin .form-field .form-field-input .form-field-flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
}

.rk-admin .form-field>label {
    display: block;
    width: 140px;
    float: left;
    position: absolute;
    left: 20px;
    top: 0;
    line-height: 30px;
    padding-top: 10px;
    font-size: 14px;
    font-weight: bold;
}

.rk-admin .form-field.long-label>label {
    width: 230px;
    text-overflow: ellipsis;
    overflow: initial;
    line-height: var(--default_line_height);
}

.rk-admin .form-field.last {
    margin-bottom: 0;
    border: none;
    padding-bottom: 0;
}

.rk-admin .form-field .warning {
    color: #666;
}


.rk-admin .form-field .field-notes {
    color: var(--lightest_legible_grey);
    margin-top: 5px;
}

.rk-admin .sub-field {
    margin-top: 5px;
    position: relative;
}

.rk-admin .sub-field label {
    position: relative;
    font-size: 12px;
    font-weight: bold;
    left: 0;
    float: none;
    display: block;
}

.rk-admin .form-field .sub-field label {
    left: 0 !important;
}

.rk-admin .form-field.form-field-group-stacked {
    padding-left: 0;
    padding-right: 0;
    display: flex;
    flex-direction: column;
}

.rk-admin .form-field.form-field-group-stacked label {
    position: relative;
    line-height: 1.4;
    width: auto;
    padding-top: 0;
    font-size: 14px;
    font-weight: bold;
}

.rk-admin .checkbox-field label {
    display: flex;
    align-items: center;
    margin-left: 5px;
}

.rk-admin .inline-form {
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.rk-admin .inline-form .error-message {
    display: inline-block;
    padding-left: 10px;
    color: red;
}

.rk-admin .save-bar {
    text-align: right;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    border-bottom: solid 1px #eee;
}

.rk-admin .master-table table {
    width: 100%;
    table-layout: fixed;
}

.rk-admin .master-table table th {
    text-transform: uppercase;
    font-size: 11px;
    padding: 10px;
    color: var(--lightest_legible_grey);
}

.rk-admin .master-table table td {
    padding: 10px;
    cursor: pointer;
    color: #4c4c4c;
    font-size: 12px;
}

.rk-admin .master-table table .label-cell,
.rk-admin .master-table table .label-cell {
    width: 173px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.rk-admin .master-table table span.stop-sign {
    display: inline-block;
    margin-right: 4px;
    transform: rotate(90deg);
    font-size: 16px;
    position: relative;
    top: 2px;
    line-height: 12px;
}

.rk-admin .master-table table td.action-cell,
.rk-admin .master-table table td.icon-button {
    color: var(--icon-grey);
}

.rk-admin .master-table table td.action-cell {
    width: 10px;
    text-align: right;
    cursor: pointer;
}

.rk-admin .master-table table .action-cell i {
    cursor: pointer;
}

.rk-admin .master-table table td:hover {
    color: var(--blue);
}

.rk-admin .master-table table td.action-cell:hover,
.rk-admin .master-table table td.icon-button:hover {
    color: var(--icon-grey-hover);
}

.rk-admin .master-table table td.action-cell .icon-image,
.rk-admin .master-table table td.icon-button .icon-image {
    height: 1em;
    width: auto;
    vertical-align: -0.125em;
    filter: var(--icon-grey-filter);
}

.rk-admin .master-table table td.action-cell:hover .icon-image,
.rk-admin .master-table table td.icon-button:hover .icon-image {
    filter: var(--icon-grey-hover-filter);
}

.rk-admin .master-table table tr.selected td,
.rk-admin .master-table table tr.selected:hover td {
    background: var(--background-5);
}

.rk-admin .new-organization {
    border-radius: var(--border_radius);
    padding: 20px;
}

.rk-admin .new-organization .title {
    line-height: 30px;
    font-size: 21px;
    padding-bottom: 5px;
    font-weight: bold;
}

.rk-admin .new-organization .sub-title {
    font-size: 14px;
    color: #666666;
}

.rk-admin .settings {
    padding-left: 20px;
    padding-top: 20px;
    padding-right: 20px;
}

.rk-admin .help {
    color: #bababa;
    font-size: 14px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 3px;
}

.rk-admin .help :hover {
    color: #666666;
}

.rk-admin .help[aria-expanded="true"] {
    color: #666666;
}

.rk-admin .detail h2 {
    height: auto;
    line-height: 30px;
    font-size: 30px;
    padding-bottom: 10px;
    border-bottom: 1px solid #d9d9d9;
}

.rk-admin input.ng-invalid.ng-touched {
    border-color: red;
    background-color: #ffeeee;
}

.rk-admin .error-message {
    background-color: #ffeeee;
    font-size: 14px;
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
    line-height: 30px;
    margin-left: 20px;
}

.rk-admin .error-message i {
    color: red;
    padding-right: 5px;
}

.rk-admin .section-header {
    padding: 10px 20px 10px 20px;
    line-height: 20px;
}

.rk-admin .section-header .section-header-title {
    font-size: 16px;
    padding-bottom: 10px;
    padding-top: 10px;
}

.rk-admin .section-header p {
    margin-bottom: 10px;
}

.rk-admin .section-select {
    border: solid 1px #ddd;
    margin-left: 20px;
    width: 230px;
    border-radius: var(--border_radius);
    margin-top: 10px;
    overflow: hidden;
    box-sizing: border-box;
}

.rk-admin .section-select .section-select-title {
    padding: 10px;
    font-weight: bold;
    background: #f2f2f2;
}

.rk-admin .section-select .section {
    border-top: solid 1px #eee;
}

.rk-admin .section-select .section a {
    display: block;
    padding: 10px;
    text-decoration: none;
}

.rk-admin .section-select .section a:hover,
.rk-admin .section-select .section a.selected {
    background: var(--selected);
}

.rk-admin .section-select .section a .fa {
    width: 20px;
}

.rk-admin .no-items-indicator {
    text-align: center;
    line-height: 1.3;
    margin: 0 auto;
    padding: 10px 20px;
}

.rk-admin .no-items-indicator .no-items-title {
    padding-top: 50px;
    font-size: 40px;
}

.rk-admin .no-items-indicator .sso-required-title {
    padding-top: 50px;
    padding-bottom: 20px;
    font-size: 40px;
}

.rk-admin .no-items-indicator .no-items-description {
    padding-bottom: 20px;
    font-size: 20px;
}

.rk-admin .no-items-indicator .sso-required-idp-link {
    padding-bottom: 20px;
    font-size: 20px;
}

.rk-admin .no-items-indicator .add-button {
    color: var(--primary);
    font-size: 30px;
    cursor: pointer;
}

.rk-admin .no-items-indicator .add-button:hover {
    color: var(--primary-hover);
}

.rk-admin .no-items-indicator .add-button .tippy-popover,
.rk-admin .tippy-popover {
    color: var(--lightest_legible_grey);
    opacity: .7;
    font-size: 14px;
    height: var(--min_desktop_target);
    width: var(--min_desktop_target);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--transition);
    cursor: pointer;
}

.rk-admin .no-items-indicator .add-button .tippy-popover:hover,
.rk-admin .tippy-popover:hover {
    color: var(--lightest_legible_grey);
    opacity: 1;
}

.rk-admin .loader {
    text-align: center;
    padding: 20px;
    font-size: 14px;
    width: 100%;
    display: flex;
    justify-content: center;
}

.loading-indicator-small {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.rk-admin .feedback .stacked-form-field {
    padding-top: 10px;
    padding-bottom: 10px;
}

.rk-admin .feedback .stacked-form-field.last {
    border-top: 1px solid #d9d9d9;
}

.rk-admin .feedback label {
    padding-top: 5px;
    padding-bottom: 5px;
    display: block;
    font-weight: bold;
    font-size: 18px;
}

.rk-admin .feedback input,
.rk-admin .feedback textarea {
    width: 600px;
}

.rk-admin .feedback textarea {
    height: 200px;
}

.rk-admin .feedback .help {
    color: #666666;
    font-size: 14px;
    padding-top: 5px;
    padding-bottom: 5px;
    width: 600px;
}

.rk-admin .minimal-table table {
    width: 100%;
}

.rk-admin .minimal-table table .spacer {
    width: 5px;
}

.rk-admin .minimal-table table .spacer-5 {
    padding-left: 0;
    padding-right: 0;
    width: 5px;
}

.rk-admin .minimal-table table tr th,
.rk-admin .minimal-table table tr td {
    padding: 5px;
    line-height: var(--default_line_height);
    padding-bottom: 10px;
    padding-top: 10px;
}

.rk-admin .minimal-table table tr td.button-cell {
    padding-top: 5px;
    padding-bottom: 5px;
    position: relative;
}

.rk-admin .minimal-table table tr th {
    font-size: 11px;
    vertical-align: bottom;
    border-bottom: var(--border);
    text-transform: uppercase;
}

.rk-admin .minimal-table table tr td {
    border-bottom: var(--border);
    vertical-align: top;
}

.rk-admin .minimal-table table tbody tr.alternating {
    background: var(--background-2);
}

.rk-admin .minimal-pagination-bar-wrapper {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    height: 41px;
    box-sizing: border-box;
    text-align: center;
}

.rk-admin .minimal-pagination-bar-wrapper .minimal-pagination-bar {
    display: inline-block;
    border: solid 1px #ddd;
    background: var(--ce-grey-5);
    padding: 5px;
    border-radius: var(--border_radius) var(--border_radius) 0px 0px;
    border-bottom: none;
}

.rk-admin .minimal-pagination-bar-wrapper .minimal-pagination-bar .editor-controls-button {
    background: #fff;
}

.rk-admin .user-items-wrapper {
    margin-top: 5px;
}

.rk-admin .user-item {
    padding-left: 5px;
    padding-right: 5px;
    border: solid 1px #ddd;
    background: #f2f2f2;
    border-radius: 2px;
    margin-right: 5px;
    float: left;
    clear: both;
    margin-bottom: 5px;
}

.rk-admin .user-project-institutions,
.rk-admin .user-items-wrapper {
    clear: both;
    padding-bottom: 10px;
}

.rk-admin .user-item a {
    color: #666;
}

.rk-admin .project-settings-section-text {
    line-height: 18px;
}

.rk-admin .admin-table .team-name {
    font-size: 14px;
    font-weight: bold;
}

.rk-admin .study-permissions {
    margin-bottom: 10px;
}

.rk-admin .study-permissions:last-of-type {
    margin-bottom: 0;
}

.rk-admin .study-permissions .study-name {
    font-weight: bold;
}

.rk-admin .rk-studio-dropdown {
    position: absolute;
    left: 10px;
    top: 50px;
    border: solid 1px #d9d9d9;
    border-radius: 2px;
    background: #FFF;
    box-shadow: var(--box-shadow-2);
    width: 700px;
    z-index: 1;
}

.rk-admin .rk-studio-dropdown.rk-studio-popup {
    top: -250px;
}

.rk-admin .rk-studio-dropdown .dropdown-header {
    border-bottom: solid 1px #e5e5e5;
    background: #f9f9f9;
    line-height: 20px;
}

.rk-admin .rk-studio-dropdown .dropdown-header .dropdown-header-text {
    padding: 10px;
    font-weight: bold;
}

.rk-admin .rk-studio-dropdown .dropdown-header table {
    width: 100%;
}


.rk-admin .rk-studio-dropdown .dropdown-header table tr td {
    text-align: left;
    padding: var(--md_padding);
    text-transform: uppercase;
    font-size: 11px;
    line-height: 10px;
    font-weight: bold;
}

.rk-admin .rk-studio-dropdown table tr td {
    text-align: left;
    padding: 10px;
    font-size: 12px;
    line-height: 16px;
}

.rk-admin .rk-studio-dropdown .dropdown-content-box {
    max-height: 250px;
    overflow: auto;
}

.rk-admin .rk-studio-dropdown .dropdown-content table {
    width: 100%;
}

.rk-admin .rk-studio-dropdown .dropdown-content table tr {
    border-bottom: solid 1px #e5e5e5;
    cursor: pointer;
}

.rk-admin .rk-studio-dropdown .dropdown-content table tr:hover {
    color: var(--blue);
    background: var(--background-2);
}

.rk-admin .rk-studio-dropdown .dropdown-content table tr.selected {
    background: var(--selected);
}

.rk-admin .rk-studio-dropdown .dropdown-content .validation-error {
    padding: 10px;
    border-bottom: solid 1px #e5e5e5;
}

.rk-admin .service-account-key {
    display: block;
    padding-left: 5px;
    padding-right: 20px;
    border: solid 1px #ddd;
    background: #f2f2f2;
    border-radius: 2px;
    margin-right: 5px;
    color: #666;
    position: relative;
    margin-bottom: 5px;
}

.rk-admin .service-account-key .key-id {
    font-weight: bold;
}

.rk-admin .service-account-key .fa-trash {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
}

.rk-admin .service-account-key:last-child {
    margin-bottom: 0;
}

.rk-admin .panel-tabs {
    border-bottom: solid 1px var(--border_color);
    display: flex;
    padding: 0 10px;
    position: sticky;
    top: 0;
    background: #FFF;
    z-index: 2;
}

.rk-admin .panel-tabs .panel-tab {
    float: left;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 30px;
    cursor: pointer;
    font-size: 11px;
    color: var(--lightest_legible_grey);
}

.rk-admin .panel-tabs .panel-tab:hover {
    color: var(--blue);
}

.rk-admin .panel-tabs .panel-tab.selected,
.rk-admin .panel-tabs .panel-tab.selected.highlight {
    background: #FFF;
    color: var(--default_text_color);
    border-bottom: var(--tab_active_secondary);
}

.rk-admin .panel-tabs .panel-tab.selected {
    cursor: default;
}

.rk-admin .panel-tabs .panel-tab.highlight {
    color: var(--blue);
}

.rk-admin .form-item-list {
    width: 100%;
    margin-bottom: 12px;
}

.rk-admin .form-item-editor {
    border-top: solid 1px #d9d9d9;
    background: white;
}

.rk-admin .form-item-editor.ui-sortable-helper {
    display: table;
}

.rk-admin .form-item-editor.last-form-item {
    border-bottom: solid 1px #d9d9d9;
}

.rk-admin .form-item-editor .drag-handle {
    vertical-align: top;
    min-width: 20px;
    height: var(--min_desktop_target);
    display: flex;
    align-items: center;
    cursor: move;
}

.rk-admin .form-item-editor .form-item-title {
    line-height: 1.2;
    position: relative;
    display: flex;
    flex: 1;
}

.rk-admin .form-item-editor .form-item-title .fa,
.rk-admin .form-item-editor .form-item-title .icon-image-button,
.rk-admin .action-bar .add-form-item-button {
    padding: 0;
    height: var(--min_desktop_target);
    width: var(--min_desktop_target);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.rk-admin .form-item-editor .form-item-title .fa.expand-icon {
    width: var(--md_padding);
    color: var(--blue);
    justify-content: flex-start;
}

.rk-admin .form-item-editor .form-item-title .action-bar {
    display: flex;
    position: relative;
}

.rk-admin .form-item-editor .form-item-editor-content {
    width: 100%;
}

.rk-admin .form-item-editor .form-item-title a {
    text-decoration: none;
    min-height: var(--min_desktop_target);
    padding: 3px 0;
    display: flex;
    align-items: center;
    flex: 1;
}

.rk-admin .form-item-editor .form-item-title:hover a,
.rk-admin .form-item-editor .form-item-title:hover .fa.expand-icon {
    color: var(--blue-hover);
}

.rk-admin .form-item-editor .form-item-main {
    background: var(--ce-grey-3);
    padding-top: 8px;
}

.rk-admin .action-bar {
    position: absolute;
    right: 0;
    top: 0;
}

.rk-admin .action-bar i {
    padding: 10px 10px 0 0;
    color: var(--icon-grey);
    line-height: 20px;
}

.rk-admin .action-bar .spacer {
    display: inline-block;
    width: 7px;
    padding: 10px 10px 0 0;
}

.rk-admin .action-bar i:hover {
    color: var(--icon-grey-hover);
}

.rk-admin .action-bar i {
    cursor: pointer;
}

.rk-admin .action-bar .icon-image-button {
    /* match the sibling ".action-bar i" line box so the trash SVG aligns with the caret/arrow font-icons */
    padding: 10px 10px 0 0;
    line-height: 20px;
    cursor: pointer;
}

.rk-admin .action-bar .icon-image-button .icon-image {
    /* 0.85em (not 1em): a tight-viewBox SVG fills its whole box, so it must be
       smaller than 1em to visually match the padded caret/arrow/copy font-glyphs beside it */
    height: 0.85em;
    width: auto;
    vertical-align: middle;
    filter: var(--icon-grey-filter);
}

.rk-admin .action-bar .icon-image-button:hover .icon-image {
    filter: var(--icon-grey-hover-filter);
}

.rk-admin .step-checkbox-field {
    padding: 5px 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--sm_padding);
}

.rk-admin .step-checkbox-field label {
    font-weight: bold;
    font-size: 11px;
    color: #4c4c4c;
    display: inline-block;
    margin-left: 5px;
    padding: 0;
}

.rk-admin .editor-form-field label .help {
    font-size: 11px;
    padding: 0;
    padding-left: 3px;
}

.rk-admin .editor-form-field .step-checkbox-field label {
    display: inline-block;
    margin-left: 5px;
    padding: 0;
}

.rk-admin .preview-notification {
    margin: 0px auto;
    width: 700px;
    position: relative;
    margin-top: 30px;
    margin-bottom: 30px;
    z-index: 5001;
    border-radius: 5px;
    overflow: hidden;
    background: #FFF;
}

.rk-admin .qr-code-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.rk-admin .qr-code-child {
    padding: 8px;
}

.rk-admin .trust-button {
    padding: 20px;
}

.rk-admin .redcap-instrument-description {
    font-style: italic;
    font-size: 0.8em;
}

.rk-admin .mobile_only {
    display: none;
}

.rk-admin .restricted-indicator {
    font-size: .6em;
    position: relative;
    top: -10px;
    width: 5px;
    margin: 0;
    padding: 0;
}

@media screen and (min-width: 768px) {
    .rk-admin .new-organization {
        margin: 5px 20px;
        border: none;
    }
}

@media screen and (max-width: 768px) {

    /* form elements */
    .rk-admin .admin-input,
    .rk-admin .admin-select,
    .rk-admin .image-upload,
    .control-bar .admin-input,
    .control-bar .admin-select,
    .rk-admin .editor-controls-button {
        width: auto;
        min-height: var(--min_touch_target);
        min-width: var(--min_touch_target);
        margin-bottom: var(--target_spacing);
        margin-right: var(--target_spacing);
    }

    .rk-admin .admin-input[type="checkbox"] {
        min-width: 20px !important;
        min-height: 20px !important;
        width: 20px !important;
        height: 20px !important;
    }

    .rk-admin button,
    .rk-admin .button {
        min-height: var(--min_touch_target);
        min-width: var(--min_touch_target);
        display: flex;
        align-items: center;
    }

    .rk-admin .admin-select {
        height: var(--min_touch_target);
        margin-left: 0;
        /* fixes issue specific to ios chrome, but not desktop chrome or safari */
    }

    .rk-admin .image-upload {
        display: flex !important;
        align-items: center;
    }

    .rk-admin .editor-controls-button {
        display: flex;
        align-items: center;
    }

    .rk-admin .form-field {
        padding-left: 0;
        display: flex;
        flex-direction: column;
    }

    .rk-admin .form-field.long-label {
        display: flex;
        flex-direction: column;
        padding-left: 0;
        padding: 10px 0;
        margin: 0 10px;
        border-bottom: var(--border);
    }

    .rk-admin .admin-input {
        width: auto;
    }

    .rk-admin .form-field.long-label .form-field-input {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .form-field-input {
        display: flex;
        flex-wrap: wrap;
    }

    .form-field-input span {
        display: flex;
        align-items: center;
    }

    .rk-admin .form-field.long-label .form-field-input>* {
        margin-right: 5px;
    }

    .rk-admin .form-field.long-label .form-field-input>*:last-child {
        margin-right: 0;
    }

    .rk-admin .form-field>label {
        position: relative;
        left: 0;
        font-size: inherit;
        padding-bottom: 5px;
        padding-top: 0;
        line-height: initial;
    }

    .rk-admin .form-field .field-notes {
        word-break: break-word;
        margin: 3px 0;
    }

    /* layout */
    .rk-admin .items-list {
        margin: 0;
    }

    .rk-admin .control-bar,
    .rk-admin .search-bar {
        padding: var(--md_padding) var(--md_padding) calc(var(--md_padding) - var(--target_spacing)) var(--md_padding);
    }

    .rk-admin .control-bar .control-bar-right {
        width: 100%;
    }

    .rk-admin .rk-studio-dropdown {
        max-width: calc(100% - 10px);
        left: 5px;
    }

    .rk-admin .mobile_only {
        display: flex;
        align-items: center;
    }

    .rk-admin .hide_on_mobile {
        display: none !important;
    }

    .rk-admin .minimal-pagination-bar-wrapper .minimal-pagination-bar {
        display: flex;
        margin: 0 auto;
        align-items: center;
        justify-content: space-between;
        max-width: 300px;
        position: relative;
        left: 0;
    }
}

/* Accordion (TODO: begin refactoring this and other components from this file into separate files in a shared folder) */

.rk-admin .accordion {
    border: var(--border);
    border-radius: var(--border_radius);
    box-shadow: var(--box-shadow);
    margin-bottom: var(--sm_padding);
}

.rk-admin .accordion-header {
    display: flex;
    cursor: pointer;
    flex-direction: row;
    align-items: center;
    padding: var(--md_padding);
    width: 100%;
}

.rk-admin .accordion-header svg {
    min-width: 20px;
    padding-right: inherit;
}

.rk-admin .accordion-title {
    margin-top: 0;
    font-weight: 500;
}

.rk-admin .accordion-content {
    padding: 0 var(--md_padding) var(--sm_padding) var(--md_padding);
}

.rk-admin .accordion-content h3 {
    border-top: var(--border);
    padding-top: var(--md_padding);
}

@media screen and (min-width: 768px) {
    .rk-admin .accordion-content {
        padding: 0 var(--lg_padding) var(--md_padding) var(--lg_padding);
    }
}

/* SVG ICONS */
.rk-admin .master-table table th.icon-button,
.rk-admin .master-table table td.icon-button,
.rk-admin .icon-button {
    min-height: var(--min_desktop_target);
    width: var(--min_desktop_target);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    cursor: pointer;
}

.rk-admin .icon-image {
    padding: 0;
    width: 12px;
    min-height: 10px;
    filter: var(--lightest-legible-grey-filter);
}

.rk-admin .icon-button:hover .icon-image {
    filter: var(--blue-filter);
}

.rk-admin .editor-controls-button .icon-image {
    margin-right: 4px;
}

.rk-admin .editor-controls-button.confirm-button .icon-image,
.rk-admin .editor-controls-button.primary-button .icon-image {
    filter: var(--white-filter);
}

.rk-admin .editor-controls-button.open .icon-image,
.rk-admin .editor-controls-button.secondary-button .icon-image {
    filter: var(--blue-filter);
}

.rk-admin .icon-button .icon-image {
    margin-right: 0;
}

@media screen and (max-width: 768px) {
    .rk-admin .icon-button {
        height: var(--min_touch_target);
        width: var(--min_touch_target);
    }
}


/* Pagination */

.rk-admin .pagination-bar-wrapper {
    box-sizing: border-box;
    text-align: center;
    font-size: var(--text_sm);
    font-weight: normal;
    display: flex;
    justify-content: flex-end;
    /* eliminates jump on page load: */
    min-height: 42px;
}

.rk-admin .pagination-bar span {
    padding: 0 5px;
    white-space: nowrap;
}

.rk-admin .pagination-bar-wrapper .pagination-bar {
    display: flex;
    align-items: center;
    padding: var(--sm_padding) calc(var(--sm_padding) - var(--target_spacing)) calc(var(--sm_padding) - var(--target_spacing)) var(--sm_padding);
}

.rk-admin .pagination-bar .pagination-nav {
    display: flex;
    align-items: center;
    border-left: var(--border);
    padding-left: 10px;
    margin-left: 10px;
}
.rk-admin .pagination-bar .pagination-nav .admin-input {
    border: var(--border);
}
.rk-admin .pagination-bar-wrapper .pagination-bar .editor-controls-button {
    padding: 0;
    display: flex;
    margin: 0;
}

.rk-admin .pagination-bar .icon-image {
    width: 11px;
    margin-right: 0;
}

.rk-admin .pagination-bar .fa-angle-right,
.rk-admin .pagination-bar .fa-angle-left {
    font-size: 16px;
}

.rk-admin .pagination-bar .icon-image.vertical-bar {
    height: 18px;
    transform: rotate(90deg);
    width: 14px;
    margin: 0 -4px;
    opacity: .8;
}

.rk-admin .pagination-bar-wrapper .pagination-bar .editor-controls-button:disabled {
    display: none;
}

.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input {
    padding: 2px 5px;
    height: 28px;
    min-height: 28px;
    line-height: 22px;
    text-align: center;
    border-radius: var(--border_radius);
    outline: none;
    transition: none;
    margin: 0 0 0 1px;
}

.rk-admin .pagination-bar-wrapper .admin-input,
.rk-admin .pagination-bar-wrapper .pagination-nav .editor-controls-button {
    border: 1px solid transparent;
    background-color: transparent;
}

.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input:hover,
.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input:active,
.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input:focus,
.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input:focus-visible,
.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input:focus-within {
    border-radius: var(--border_radius);
    border-color: transparent;
    outline: 1px solid var(--highlight-border);
    outline-offset: -2px;
    background-color: #fff;
}

.rk-admin .pagination-bar-wrapper .pagination-bar .editor-controls-button:hover {
    background: var(--ce-grey-4);
}

.rk-admin .pagination-bar-wrapper.bottom-pagination.fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: var(--border);
    background: var(--ce-grey-1);
}

@media screen and (max-width: 768px) {
    .rk-admin .pagination-bar-wrapper .pagination-bar {
        display: flex;
        margin: 0 auto;
        align-items: center;
        justify-content: space-between;
        max-width: 300px;
        position: relative;
        left: 0;
    }

    .rk-admin .pagination-bar-wrapper.bottom-pagination {
        position: sticky;
        bottom: 0;
        margin: 0;
        background: var(--ce-grey-2);
        border-top: var(--border);
        border-radius: 0;
    }

    .rk-admin .pagination-bar-wrapper .pagination-bar span,
    .rk-admin .pagination-bar-wrapper .pagination-bar .admin-input,
    .rk-admin .pagination-bar-wrapper .pagination-bar .editor-controls-button {
        margin-bottom: var(--target_spacing);
    }

}

/* helper classes */

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}

/* overrides the server-injected "Signing out..." spinner globally across the admin */
.careev-modal-spinner .loading-indicator-container {
    background-color: transparent;
    box-shadow: none;
    border-radius: 0;
    width: auto;
    padding: 0;
    top: 50%;
    transform: translateY(-50%);
}
.careev-modal-spinner .loading-indicator .loading-medium {
    font-size: clamp(16px, 2.5vw, 28px) !important;
    background-color: var(--ce-grey-70);
    border-radius: 0.8em;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    padding: 1.2em 2.4em;
    width: auto;
    max-width: 100%;
    min-width: auto;
    display: inline-flex;
    align-items: center;
    gap: 0.6em;
    flex-wrap: wrap;
    justify-content: center;
}

.careev-modal-spinner .loading-indicator .loading-medium span {
    color: white;
    font-size: 1em;
    opacity: 0.9;
    font-weight: 400;
    letter-spacing: 0.01em;
}`, "",{"version":3,"sources":["webpack://./src/admin.css"],"names":[],"mappings":"AAAA;IACI,kJAAkJ;AACtJ;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;;IAElC,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B;IAC/B,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;;IAEhC,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,+BAA+B;IAC/B,+BAA+B;;IAE/B,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;;IAEtB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;;IAEvB,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;IACvB,kCAAkC;IAClC,kCAAkC;IAClC,uBAAuB;IACvB,uBAAuB;IACvB,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,8BAA8B;;IAE9B,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;;IAEvB,sCAAsC;IACtC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,8CAA8C;IAC9C,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,gDAAgD;IAChD,8CAA8C;IAC9C,8CAA8C;IAC9C,mCAAmC;IACnC,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,mIAAmI;IACnI,+BAA+B;IAC/B,mIAAmI;IACnI,qCAAqC;IACrC,0IAA0I;IAC1I,wCAAwC;IACxC,iCAAiC;IACjC,sCAAsC;IACtC,6BAA6B;IAC7B,mCAAmC;IACnC,yBAAyB;IACzB,8BAA8B;IAC9B,2BAA2B;IAC3B,iCAAiC;IACjC,6BAA6B;IAC7B,kCAAkC;;IAElC,uBAAuB;IACvB,sBAAsB;IACtB,kCAAkC;IAClC,2CAA2C;IAC3C,8BAA8B;IAC9B,uIAAuI;IACvI,wBAAwB;;IAExB,uBAAuB;IACvB,sCAAsC;IACtC,8BAA8B;IAC9B,gCAAgC;IAChC,sCAAsC;IACtC,4BAA4B;IAC5B,gCAAgC;IAChC,8BAA8B;IAC9B,oCAAoC;IACpC,sIAAsI;IACtI,6IAA6I;IAC7I,uCAAuC;IACvC,0CAA0C;IAC1C,qHAAqH;IACrH,wDAAwD;IACxD,qDAAqD;;IAErD,cAAc;IACd,oEAAoE;;IAEpE,eAAe;IACf,0BAA0B;IAC1B,kCAAkC;IAClC,iCAAiC;IACjC,uCAAuC;IACvC,oBAAoB;IACpB,2BAA2B;IAC3B,wBAAwB;IACxB,4CAA4C;IAC5C,8CAA8C;IAC9C,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,mCAAmC;IACnC,mDAAmD;IACnD,qCAAqC;IACrC,2BAA2B;IAC3B,sBAAsB;IACtB,6BAA6B;IAC7B,wBAAwB;;IAExB,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;;IAElB,8CAA8C;IAC9C,0CAA0C;IAC1C,0CAA0C;IAC1C,wCAAwC;IACxC,uCAAuC;AAC3C;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;;IAEnC,iCAAiC;IACjC,qCAAqC;IACrC,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA;EACE;;uBAEqB;EACrB,qCAAqC;EACrC,iCAAiC;EACjC,wCAAwC;EACxC,uCAAuC;EACvC,oCAAoC;EACpC,wCAAwC;EACxC,uEAAuE;EACvE,4CAA4C;EAC5C,kCAAkC;EAClC,gDAAgD;EAChD,8CAA8C;EAC9C,6CAA6C;EAC7C,8CAA8C;EAC9C,iEAAiE;EACjE,2CAA2C;EAC3C,4CAA4C;EAC5C,8CAA8C;EAC9C,6CAA6C;EAC7C,0CAA0C;EAC1C,8CAA8C;EAC9C,0DAA0D;EAC1D,6CAA6C;EAC7C,8CAA8C;EAC9C,gDAAgD;EAChD,+CAA+C;EAC/C,4CAA4C;EAC5C,gDAAgD;AAClD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA,eAAe;;AAEf;IACI,mCAAmC;IACnC,eAAe;IACf,gBAAgB;AACpB;;AAEA,QAAQ;AACR;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;IAGI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;;AAGA,kBAAkB;;AAElB;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;;;IAKI,WAAW;IACX,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,mCAAmC;IACnC,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;;;IAGI,mCAAmC;AACvC;;AAEA;;;IAGI,yCAAyC;AAC7C;;AAEA;;;;IAII,iCAAiC;IACjC,eAAe;AACnB;;;AAGA;;;IAGI,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;IACnC,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,yDAAgK;IAChK,4BAA4B;IAC5B,qCAAqC;IACrC,wBAAwB;IACxB,qCAAqC;IACrC,iCAAiC;IACjC,qCAAqC;IACrC,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;;AAGA;IACI,YAAY;IACZ,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;;IAEI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,eAAe;IACf,qCAAqC;IACrC,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,mCAAmC;IACnC,qCAAqC;IACrC,iDAAiD;IACjD,mBAAmB;IACnB,+BAA+B;IAC/B,gCAAgC;IAChC,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,aAAa;IACb,cAAc;IACd,mCAAmC;AACvC;;AAEA;;IAEI,0BAA0B;IAC1B,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;IACzB,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;;;;IAKI,YAAY;IACZ,wBAAwB;IACxB,+BAA+B;IAC/B,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;;IAEI,qBAAqB;IACrB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;;;IAGI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,2BAA2B;IAC3B,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,WAAW;AACf;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,qFAAqF;IACrF,6BAA6B;IAC7B,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,yEAAyE;IACzE,yBAAyB;IACzB,WAAW;IACX,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,0BAA0B;IAC1B,gCAAgC;IAChC,WAAW;AACf;;AAEA;;IAEI,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,8GAA8G;IAC9G,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,OAAO;IACP,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,mCAAmC;IACnC,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,qBAAqB;AACzB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,mCAAmC;IACnC,WAAW;IACX,eAAe;IACf,iCAAiC;IACjC,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;;IAEI,mCAAmC;IACnC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;;IAEI,YAAY;IACZ,uCAAuC;IACvC,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,OAAO;IACP,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,4BAA4B;IAC5B,YAAY;IACZ,gEAAgE;IAChE,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,gCAAgC;IAChC,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,OAAO;AACX;;AAEA;;;IAGI,UAAU;IACV,iCAAiC;IACjC,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;IACrC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,OAAO;AACX;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uGAAuG;IACvG,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;6FACyF;IACzF,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,SAAS;IACT,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;IAChB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;;;;;;QAMI,WAAW;QACX,mCAAmC;QACnC,kCAAkC;QAClC,oCAAoC;QACpC,mCAAmC;IACvC;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;;QAEI,mCAAmC;QACnC,kCAAkC;QAClC,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,+BAA+B;QAC/B,cAAc;QACd,yEAAyE;IAC7E;;IAEA;QACI,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,eAAe;QACf,cAAc;QACd,4BAA4B;IAChC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,aAAa;IACjB;;IAEA,WAAW;IACX;QACI,SAAS;IACb;;IAEA;;QAEI,8GAA8G;IAClH;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,4BAA4B;QAC5B,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;QACb,cAAc;QACd,mBAAmB;QACnB,8BAA8B;QAC9B,gBAAgB;QAChB,kBAAkB;QAClB,OAAO;IACX;AACJ;;AAEA,wHAAwH;;AAExH;IACI,qBAAqB;IACrB,mCAAmC;IACnC,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI;QACI,gEAAgE;IACpE;AACJ;;AAEA,cAAc;AACd;;;IAGI,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,+BAA+B;QAC/B,8BAA8B;IAClC;AACJ;;;AAGA,eAAe;;AAEf;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4IAA4I;AAChJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;IACnC,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;;;;;IAKI,mCAAmC;IACnC,yBAAyB;IACzB,0CAA0C;IAC1C,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI;QACI,aAAa;QACb,cAAc;QACd,mBAAmB;QACnB,8BAA8B;QAC9B,gBAAgB;QAChB,kBAAkB;QAClB,OAAO;IACX;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,SAAS;QACT,4BAA4B;QAC5B,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;;;QAGI,oCAAoC;IACxC;;AAEJ;;AAEA,mBAAmB;;AAEnB;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;AACb;;AAEA,qFAAqF;AACrF;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,QAAQ;IACR,2BAA2B;AAC/B;AACA;IACI,8CAA8C;IAC9C,mCAAmC;IACnC,oBAAoB;IACpB,yCAAyC;IACzC,0BAA0B;IAC1B,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B","sourcesContent":["body {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n}\n\n:root {\n    --ce-offwhite-base: #fdfdfe;\n    --ce-grey-1-base: #FBFCFC;\n    --ce-grey-2-base: #f8f9fb;\n    --ce-grey-3-base: #F4F6F7;\n    --ce-grey-4-base: #F1F2F5;\n    --ce-grey-5-base: #EDEFF2;\n    --ce-grey-10-base: #DFE1E7;\n    --ce-grey-20-base: #C6CAD5;\n    --ce-grey-30-base: #A9ADBF;\n    --ce-grey-40-base: #8E90A6;\n    --ce-grey-50-base: #73748B;\n    --ce-grey-55-base: #6B6B81;\n    --ce-grey-60-base: #595A6B;\n    --ce-grey-70-base: #434351;\n    --ce-grey-80-base: #2E2D35;\n    --ce-grey-90-base: #1D1C21;\n    --ce-grey-95-base: rgb(27, 26, 31);\n    --ce-grey-96-base: rgb(25, 25, 29);\n    --ce-grey-97-base: rgb(22, 21, 25);\n    --ce-grey-98-base: rgb(20, 19, 23);\n    --ce-grey-99-base: rgb(17, 16, 19);\n\n    --ce-blue-muted-1-base: #f9fcfd;\n    --ce-blue-muted-2-base: #f6fafd;\n    --ce-blue-muted-3-base: #f0f7fb;\n    --ce-blue-muted-4-base: #eaf3fa;\n    --ce-blue-muted-5-base: #e4f0f8;\n    --ce-blue-muted-10-base: #cee4f4;\n    --ce-blue-muted-20-base: #a8cfec;\n    --ce-blue-muted-30-base: #75b4e1;\n    --ce-blue-muted-40-base: #4698d3;\n    --ce-blue-muted-50-base: #187ac1;\n    --ce-blue-muted-55-base: #0b70ba;\n    --ce-blue-muted-60-base: #005da6;\n    --ce-blue-muted-70-base: #004483;\n    --ce-blue-muted-80-base: #002e5b;\n    --ce-blue-muted-90-base: #001d3b;\n\n    --ce-red-2: #FEF5F5;\n    --ce-red-3: #FDF3F4;\n    --ce-red-4: #FDEFF0;\n    --ce-red-5: #FCEAEA;\n    --ce-red-10: #F9D9DA;\n    --ce-red-20: #F4BBBD;\n    --ce-red-muted-55-base: #CE2C32;\n    --ce-red-muted-70-base: #8F0005;\n\n    --ce-green-1: #F8FDFB;\n    --ce-green-2: #F1FBF6;\n    --ce-green-3: #EAF9F2;\n    --ce-green-5: #DBF4E9;\n    --ce-green-10: #BDEAD7;\n    --ce-green-20: #8AD9B8;\n    --ce-green-30: #45C28F;\n    --ce-green-40: #23A482;\n    --ce-green-55: #007B6C;\n    --ce-green-70: #004E45;\n\n    --ce-violet-5: #F9E9FF;\n    --ce-violet-10: #F4D6FF;\n    --ce-violet-40: #CF5EFF;\n    --ce-violet-55: #A22AE9;\n\n    --ce-indigo-1: rgb(251, 252, 255);\n    --ce-indigo-2: rgb(247, 248, 255);\n    --ce-indigo-3: rgb(244, 245, 255);\n    --ce-indigo-4: rgb(241, 241, 255);\n    --ce-indigo-5: #EDEDFF;\n    --ce-indigo-10: #DEDDFF;\n    --ce-indigo-20: rgb(200, 196, 253);\n    --ce-indigo-30: rgb(172, 163, 250);\n    --ce-indigo-40: #8F82F6;\n    --ce-indigo-55: #6653F0;\n    --ce-indigo-60: rgb(83, 61, 224);\n    --ce-indigo-70: rgb(54, 28, 201);\n    --ce-indigo-80: rgb(36, 16, 142);\n    --ce-indigo-90: rgb(22, 8, 98);\n\n    --ce-yellow-1: #FFFCE6;\n    --ce-yellow-2: #FFF9CF;\n    --ce-yellow-3: #FFF7C3;\n    --ce-yellow-5: #FFF094;\n    --ce-yellow-10: #FFE02B;\n    --ce-orange-1: #FFFBF6;\n    --ce-orange-4: #FFF1E3;\n    --ce-orange-10: #FFDBB8;\n    --ce-orange-40: #EC6C05;\n    --ce-orange-55: #B15103;\n\n    --ce-offwhite: var(--ce-offwhite-base);\n    --ce-grey-1: var(--ce-grey-1-base);\n    --ce-grey-2: var(--ce-grey-2-base);\n    --ce-grey-3: var(--ce-grey-3-base);\n    --ce-grey-4: var(--ce-grey-4-base);\n    --ce-grey-5: var(--ce-grey-5-base);\n    --ce-grey-10: var(--ce-grey-10-base);\n    --ce-grey-20: var(--ce-grey-20-base);\n    --ce-grey-30: var(--ce-grey-30-base);\n    --ce-grey-40: var(--ce-grey-40-base);\n    --ce-grey-50: var(--ce-grey-50-base);\n    --ce-grey-55: var(--ce-grey-55-base);\n    --ce-grey-60: var(--ce-grey-60-base);\n    --ce-grey-70: var(--ce-grey-70-base);\n    --ce-grey-80: var(--ce-grey-80-base);\n    --ce-grey-90: var(--ce-grey-90-base);\n    --ce-grey-95: var(--ce-grey-95-base);\n    --ce-grey-96: var(--ce-grey-96-base);\n    --ce-grey-97: var(--ce-grey-97-base);\n    --ce-grey-98: var(--ce-grey-98-base);\n    --ce-grey-99: var(--ce-grey-99-base);\n    --ce-blue-muted-1: var(--ce-blue-muted-1-base);\n    --ce-blue-muted-2: var(--ce-blue-muted-2-base);\n    --ce-blue-muted-3: var(--ce-blue-muted-3-base);\n    --ce-blue-muted-4: var(--ce-blue-muted-4-base);\n    --ce-blue-muted-5: var(--ce-blue-muted-5-base);\n    --ce-blue-muted-10: var(--ce-blue-muted-10-base);\n    --ce-blue-muted-20: var(--ce-blue-muted-20-base);\n    --ce-blue-muted-30: var(--ce-blue-muted-30-base);\n    --ce-blue-muted-40: var(--ce-blue-muted-40-base);\n    --ce-blue-muted-50: var(--ce-blue-muted-50-base);\n    --ce-blue-muted-55: var(--ce-blue-muted-55-base);\n    --ce-blue-muted-60: var(--ce-blue-muted-60-base);\n    --ce-blue-muted-70: var(--ce-blue-muted-70-base);\n    --ce-blue-muted-80: var(--ce-blue-muted-80-base);\n    --ce-blue-muted-90: var(--ce-blue-muted-90-base);\n    --ce-red-muted-55: var(--ce-red-muted-55-base);\n    --ce-red-muted-70: var(--ce-red-muted-70-base);\n    --ce-red-55: var(--ce-red-muted-55);\n    --ce-red-40: #E66B6F;\n    --ce-red-60: #AE252A;\n    --ce-green-60: #00675B;\n    --ce-orange-60: #954403;\n}\n\n:root {\n    /* nicknames */\n    --white-filter: brightness(0) saturate(100%) invert(100%) sepia(1%) saturate(0%) hue-rotate(175deg) brightness(103%) contrast(101%);\n    --blue: var(--ce-blue-muted-55);\n    --blue-filter: brightness(0) saturate(100%) invert(28%) sepia(100%) saturate(994%) hue-rotate(180deg) brightness(98%) contrast(96%);\n    --blue-hover: var(--ce-blue-muted-70);\n    --blue-hover-filter: brightness(0) saturate(100%) invert(17%) sepia(46%) saturate(3767%) hue-rotate(192deg) brightness(94%) contrast(103%);\n    --highlight-blue: var(--ce-blue-muted-3);\n    --blue-bg: var(--ce-blue-muted-2);\n    --blue-border: var(--ce-blue-muted-10);\n    --red: var(--ce-red-muted-55);\n    --red-hover: var(--ce-red-muted-70);\n    --red-bg: var(--ce-red-2);\n    --red-border: var(--ce-red-10);\n    --green: var(--ce-green-55);\n    --green-hover: var(--ce-green-70);\n    --green-bg: var(--ce-green-2);\n    --green-border: var(--ce-green-10);\n\n    /* intent-based blues */\n    --primary: var(--blue);\n    --primary-hover: var(--blue-hover);\n    --highlight-border: var(--ce-blue-muted-20);\n    --warning: var(--ce-orange-40);\n    --warning-filter: brightness(0) saturate(100%) invert(58%) sepia(79%) saturate(3101%) hue-rotate(353deg) brightness(89%) contrast(109%);\n    --warning-hover: #ec4a05;\n\n    /* intent-based greys */\n    --background-white: var(--ce-offwhite);\n    --background: var(--ce-grey-1);\n    --background-2: var(--ce-grey-2);\n    --background-headers: var(--ce-grey-4);\n    --selected: var(--ce-grey-4);\n    --background-5: var(--ce-grey-5);\n    --icon-grey: var(--ce-grey-40);\n    --icon-grey-hover: var(--ce-grey-60);\n    --icon-grey-filter: brightness(0) saturate(100%) invert(61%) sepia(7%) saturate(776%) hue-rotate(197deg) brightness(93%) contrast(89%);\n    --icon-grey-hover-filter: brightness(0) saturate(100%) invert(51%) sepia(83%) saturate(128%) hue-rotate(199deg) brightness(51%) contrast(74%);\n    --default_text_color: var(--ce-grey-80);\n    --lightest_legible_grey: var(--ce-grey-55);\n    --lightest-legible-grey-filter: invert(46%) sepia(9%) saturate(840%) hue-rotate(201deg) brightness(89%) contrast(87%);\n    --lightest_legible_grey_against_white: var(--ce-grey-50);\n    --lightest_legible_grey_large_text: var(--ce-grey-40);\n\n    /* gradients */\n    --ce-com-gradient: linear-gradient(180deg, #E7E6F9 0%, #F3DFDB 100%);\n    \n    /* other vars */\n    --highlight_green: #28a745;\n    --red-text: var(--ce-red-muted-55);\n    --border_color: var(--ce-grey-10);\n    --border: 1px solid var(--border_color);\n    --border_radius: 5px;\n    --border_radius_cards: 10px;\n    --border_radius_lg: 20px;\n    --box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);\n    --box-shadow-2: 0 3px 12px rgba(0, 0, 0, 0.15);\n    --transition: all .1s;\n    --min-target-size: 30px;\n    --min_desktop_target: 30px;\n    --min_touch_target: 36px;\n    --min_nav_target: 40px;\n    --ideal_touch_target: 44px;\n    --nav_height: 41px;\n    --target_spacing: 3px;\n    --button_gap: 4px;\n    --lg_padding: 20px;\n    --md_padding: 10px;\n    --sm_padding: 5px;\n    --btn_padding: 8px;\n    --btn_icon_padding: 2px;\n    --tab_active: 3px solid var(--blue);\n    --tab_active_secondary: 3px solid var(--ce-grey-60);\n    --tab_inactive: 3px solid transparent;\n    --error_background: #ffeeee;\n    --error_color: #973b37;\n    --success_background: #f5ffee;\n    --success_color: #3e6c46;\n\n    /* typography */\n    --default_line_height: 1.4;\n    --text_sm: 12px;\n    --text_md: 16px;\n    --text_lg: 20px;\n    --header-title-size: 20px;\n    --font-size-default-desktop: 14px;\n    --line-height: 1.3;\n    --p-margin: 0.75em;\n    --ul-margin: 1.5em;\n\n    /* Apply CE Design system colors to toastify */\n    --toastify-color-success: rgb(17, 157, 73);\n    --toastify-color-warning: rgb(214, 114, 0);\n    --toastify-color-error: rgb(239, 55, 36);\n    --toastify-color-info: rgb(0, 127, 249);\n}\n\n@media screen and (max-width: 768px) {\n    :root {\n        --min-target-size: 36px;\n    }\n}\n\n[data-ce-theme='dark'] {\n    --ce-grey-1: var(--ce-grey-99-base);\n    --ce-grey-2: var(--ce-grey-98-base);\n    --ce-grey-3: var(--ce-grey-97-base);\n    --ce-grey-4: var(--ce-grey-96-base);\n    --ce-grey-5: var(--ce-grey-95-base);\n    --ce-grey-10: var(--ce-grey-90-base);\n    --ce-grey-20: var(--ce-grey-80-base);\n    --ce-grey-30: var(--ce-grey-70-base);\n    --ce-grey-40: var(--ce-grey-60-base);\n    --ce-grey-50: var(--ce-grey-55-base);\n    --ce-grey-55: var(--ce-grey-50-base);\n    --ce-grey-60: var(--ce-grey-40-base);\n    --ce-grey-70: var(--ce-grey-30-base);\n    --ce-grey-80: var(--ce-grey-20-base);\n    --ce-grey-90: var(--ce-grey-10-base);\n    --ce-grey-95: var(--ce-grey-5-base);\n    --ce-grey-96: var(--ce-grey-4-base);\n    --ce-grey-97: var(--ce-grey-3-base);\n    --ce-grey-98: var(--ce-grey-2-base);\n    --ce-grey-99: var(--ce-grey-1-base);\n\n    --border_color: var(--ce-grey-30);\n    --border: 1px solid var(--ce-grey-30);\n    --default_text_color: var(--ce-grey-80);\n    --background-5: var(--ce-grey-5);\n}\n\n:root {\n  /* ===================\n      Design System - Color aliases for intent-based use cases\n  =================== */\n  --ce-intent-none: var(--background-2);\n  --ce-intent-primary:  var(--blue);\n  --ce-intent-secondary: var(--ce-grey-70);\n  --ce-intent-success: var(--ce-green-55);\n  --ce-intent-danger: var(--ce-red-55);\n  --ce-intent-warning: var(--ce-orange-40);\n  /* Color for things like text that appears on top of the intent-color */\n  --ce-intent-none-contrast: var(--ce-grey-90);\n  --ce-intent-primary-contrast: #fff;\n  --ce-intent-secondary-contrast: var(--ce-grey-1);\n  --ce-intent-success-contrast: var(--ce-grey-1);\n  --ce-intent-danger-contrast: var(--ce-grey-1);\n  --ce-intent-warning-contrast: var(--ce-grey-1);\n  /* Color for a light/faded background based on the intent color.*/\n  --ce-intent-none-faded: var(--background-5);\n  --ce-intent-primary-faded: var(--blue-hover);\n  --ce-intent-secondary-faded: var(--ce-grey-40);\n  --ce-intent-success-faded: var(--ce-green-40);\n  --ce-intent-danger-faded: var(--ce-red-40);\n  --ce-intent-warning-faded: var(--ce-orange-40);\n  /* Color for an outline or border when button is focused.*/\n  --ce-intent-none-outline: var(--border_color);\n  --ce-intent-primary-outline: var(--ce-blue-60);\n  --ce-intent-secondary-outline: var(--ce-grey-70);\n  --ce-intent-success-outline: var(--ce-green-60);\n  --ce-intent-danger-outline: var(--ce-red-60);\n  --ce-intent-warning-outline: var(--ce-orange-60);\n}\n\nhtml {\n    box-sizing: border-box;\n}\n\n*,\n*:before,\n*:after {\n    box-sizing: inherit;\n}\n\n.survey-step *,\n.survey-step *:before,\n.survey-step *:after {\n    box-sizing: initial;\n}\n\n* {\n    scrollbar-width: thin;\n}\n\nhtml,\nbody,\n.rkstudio-layout {\n    min-height: 100%;\n    height: 100%;\n    overflow: auto;\n}\n\n.rkstudio-layout {\n    color: var(--default_text_color);\n    background: var(--background-white);\n}\n\n/* typography */\n\n.rk-admin .empty-state {\n    color: var(--lightest_legible_grey);\n    font-size: 24px;\n    font-weight: 500;\n}\n\n/* nav */\nnav a {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\nnav a svg[data-prefix=\"fas\"] {\n    display: none;\n}\n\nnav a svg[data-prefix=\"far\"] {\n    display: flex;\n}\n\nnav a svg {\n    width: 20px;\n    justify-content: flex-start;\n}\n\nnav a.selected {\n    color: #111;\n    background: var(--selected);\n    font-weight: bold;\n    border-radius: 100px;\n}\n\nnav a:hover svg[data-prefix=\"fas\"],\nnav a.selected svg[data-prefix=\"fas\"] {\n    display: flex;\n}\n\nnav a:hover svg[data-prefix=\"far\"],\nnav a.selected svg[data-prefix=\"far\"] {\n    display: none;\n}\n\nnav a svg {\n    margin-right: 7px;\n}\n\nnav a svg[class*=\"caret\"][data-prefix=\"fas\"],\nnav a svg[class*=\"circle-plus\"][data-prefix=\"fas\"],\nnav a svg[class*=\"circle-plus\"][data-prefix=\"far\"] {\n    margin-right: 0;\n    display: flex;\n}\n\n#current-panel {\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.rkstudio-layout {\n    font-size: 12px;\n}\n\n#support-form {\n    display: none;\n}\n\n.support-center {\n    padding: 20px;\n}\n\na:link,\na:visited {\n    color: var(--blue);\n}\n\na:hover {\n    color: var(--blue-hover);\n    text-decoration: underline;\n}\n\ninput,\nselect,\ntextarea {\n    font-size: 12px;\n}\n\n#current-panel {\n    padding: 0;\n    margin: 0;\n}\n\n.clear {\n    clear: both;\n}\n\n.page-container {\n    position: fixed;\n    height: 100%;\n    top: calc(var(--min_nav_target) + 1px);\n    width: 100%;\n    z-index: 2;\n    height: calc(100% - 40px);\n    overflow: auto;\n}\n\n.rk-admin {\n    font-size: 12px;\n    position: relative;\n    -webkit-font-smoothing: antialiased;\n}\n\n.rk-admin .clickable {\n    cursor: pointer;\n}\n\n.rk-admin .draggable {\n    cursor: move !important;\n}\n\n.rk-admin strong {\n    font-weight: bold;\n}\n\n.rk-admin .intro-content {\n    margin-left: 20px;\n    margin-right: 20px;\n    line-height: 20px;\n    margin-top: 10px;\n}\n\n.rk-admin .admin-table {\n    border: solid 1px #ddd;\n    border-radius: 2px;\n    margin-left: 20px;\n    margin-right: 20px;\n}\n\n.rk-admin .admin-table table {\n    line-height: 20px;\n    width: 100%;\n}\n\n.rk-admin .admin-table th {\n    text-transform: uppercase;\n    font-size: 12px;\n    color: #666;\n    text-align: left;\n    background: var(--background-2);\n    padding: 10px;\n    border-bottom: solid 1px #ddd;\n}\n\n.rk-admin .admin-table td {\n    font-size: 12px;\n    padding: 5px;\n    padding-left: 10px;\n    padding-right: 10px;\n    border-bottom: solid 1px #eee;\n}\n\n.rk-admin .admin-table tr.alternating {\n    background: var(--background-2);\n}\n\n.rk-admin .admin-table tr:last-child td {\n    border-bottom: none;\n}\n\n.rk-admin .admin-table.with-detail tr:hover {\n    background: var(--selected);\n    cursor: pointer;\n}\n\n.rk-admin .admin-table a {\n    text-decoration: none;\n}\n\n.rk-admin .admin-table tr.edit-panel td {\n    vertical-align: top;\n    border-top: solid 1px #eee;\n}\n\n\n/* form elements */\n\n.rk-admin .required {\n    color: var(--red-text);\n    font-weight: normal;\n    font-style: italic;\n    font-size: 13px;\n}\n\n.rk-admin .admin-input,\n.rk-admin .admin-select,\n.rk-admin .admin-textarea,\n.rk-admin .image-upload,\n.rk-admin .editor-controls-button {\n    width: auto;\n    min-height: var(--min_desktop_target);\n    min-width: var(--min_desktop_target);\n    margin-right: var(--target_spacing);\n    border-radius: var(--border_radius);\n    border-color: var(--border_color);\n    border-style: solid;\n    border-width: 1px;\n    transition: var(--transition);\n}\n\n.rk-admin .admin-input::placeholder,\n.rk-admin .admin-select::placeholder,\n.rk-admin .admin-textarea::placeholder {\n    color: var(--lightest_legible_grey);\n}\n\n.rk-admin .admin-input:hover,\n.rk-admin .admin-select:hover,\n.rk-admin .admin-textarea:hover {\n    border: 1px solid var(--highlight-border);\n}\n\n.rk-admin .admin-input:hover:disabled,\n.rk-admin .admin-input:hover[disabled=\"disabled\"],\n.rk-admin .admin-select:hover[disabled=\"disabled\"],\n.rk-admin .admin-textarea:hover[disabled=\"disabled\"] {\n    border-color: var(--border_color);\n    cursor: default;\n}\n\n\n.rk-admin .admin-input:focus-visible,\n.rk-admin .admin-select:focus-visible,\n.rk-admin .admin-textarea:focus-visible {\n    outline: 0;\n    border: 1px solid var(--blue);\n}\n\n.rk-admin .admin-input {\n    box-sizing: border-box;\n    height: 30px;\n    line-height: 24px;\n    width: auto;\n    padding-left: 10px;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    padding-right: 2px;\n    font-family: inherit;\n    max-width: 100%;\n}\n\n.rk-admin .admin-input[type=\"checkbox\"] {\n    min-width: 16px !important;\n    min-height: 16px !important;\n    width: 16px !important;\n    height: 16px !important;\n}\n\n.rk-admin .admin-input.large-input {\n    min-width: 300px;\n}\n\n.rk-admin .admin-input.interval-input {\n    width: 60px;\n}\n\n.rk-admin .admin-input.suppress-disabled-styles:disabled {\n    background: none;\n    border: none;\n    color: #333;\n    -webkit-text-fill-color: #333;\n    opacity: 1;\n    /* required on iOS */\n}\n\n.rk-admin .localized-input {\n    width: calc(100% - 94px) !important;\n}\n\n.rk-admin .url-input {\n    width: calc(100% - 115px) !important;\n}\n\n.rk-admin .locale-selector {\n    width: 80px;\n}\n\n.rk-admin .admin-select {\n    appearance: none;\n    -webkit-appearance: none;\n    transition: none;\n    line-height: 24px;\n    border-radius: var(--border_radius);\n    padding: 2px 24px 2px 8px;\n    border-color: #d9d9d9;\n    background-color: #FFF;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'%3E%3Cpath fill='%23666' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 8px center;\n    background-size: 8px 5px;\n    min-height: var(--min_desktop_target);\n    height: var(--min_desktop_target);\n    /* min-height not enough for safari */\n    max-width: 100%;\n    cursor: pointer;\n    color: #000;\n}\n\n.rk-admin .admin-select.inline {\n    width: auto !important;\n    margin-bottom: 5px;\n}\n\n\n.rk-admin .admin-textarea {\n    height: 30em;\n    border-radius: var(--border_radius);\n    width: 180px;\n    padding-left: 10px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    margin-right: 5px;\n    border: 1px solid #ccc;\n    padding-right: 2px;\n    border-color: #d9d9d9;\n    font-family: inherit;\n}\n\n.rk-admin .admin-checkbox,\n.rk-admin .admin-radio {\n    margin-top: 9px;\n    margin-bottom: 8px;\n}\n\n.checkbox-field {\n    display: flex;\n    align-items: center;\n    column-gap: 4px;\n}\n\n.checkbox-field .admin-checkbox {\n    margin-bottom: 9px;\n}\n\n.rk-admin .button {\n    border-radius: var(--border_radius);\n    padding: 0 10px;\n    cursor: pointer;\n    min-height: var(--min_desktop_target);\n    min-width: var(--min_desktop_target);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    line-height: 1.2;\n    transition: var(--transition);\n}\n\n.rk-admin .button .back-arrow {\n    padding-right: var(--md_padding);\n    font-size: 17px;\n}\n\n.rk-admin .editor-controls-button {\n    border: var(--border);\n    cursor: pointer;\n    border-radius: var(--border_radius);\n    min-height: var(--min_desktop_target);\n    padding: var(--target_spacing) var(--btn_padding);\n    font-weight: normal;\n    background: var(--background-2);\n    color: var(--default_text_color);\n    font-family: inherit;\n    font-size: var(--text_sm);\n    position: relative;\n    justify-content: center;\n    align-items: center;\n}\n\n.rk-admin .editor-controls-button>* {\n    padding: 0 2px;\n}\n\n.rk-admin .editor-controls-button>.fa {\n    padding: 0 var(--btn_icon_padding);\n}\n\n.rk-admin .combo-button-group,\n.rk-admin .combo-input-group {\n    display: flex;\n    margin-left: 0;\n    margin-right: var(--target_spacing);\n}\n\n.rk-admin .combo-button-group .editor-controls-button:first-of-type,\n.rk-admin .combo-input-group .admin-input {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    margin-right: -1px;\n    padding-right: 6px;\n}\n\n.rk-admin .combo-button-group .editor-controls-button:last-of-type,\n.rk-admin .combo-input-group .editor-controls-button {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-left: var(--border);\n}\n\n.rk-admin .editor-controls-button:hover:enabled {\n    background: var(--background-5);\n}\n\n.rk-admin .editor-controls-button.disabled,\n.rk-admin .editor-controls-button.secondary-button.disabled,\n.rk-admin .editor-controls-button:disabled,\n.rk-admin .editor-controls-button.secondary-button:disabled,\n.rk-admin .editor-controls-button.danger-button:disabled {\n    cursor: auto;\n    color: var(--ce-grey-30);\n    background: var(--background-2);\n    border: 1px solid var(--ce-grey-5);\n    cursor: auto;\n}\n\n.rk-admin .editor-controls-button.open {\n    background: #fff;\n    color: var(--primary);\n    border: 1px solid var(--primary);\n}\n\n.rk-admin .editor-controls-button.secondary-button,\n.rk-admin .editor-controls-button.outline-button {\n    color: var(--primary);\n    border: 1px solid var(--primary);\n    background: #fff;\n}\n\n.rk-admin .editor-controls-button.minimal-button,\n.rk-admin .editor-controls-button.minimal-button:hover:enabled,\n.rk-admin .editor-controls-button.minimal-button:disabled {\n    border: none;\n    background: transparent;\n}\n\n.rk-admin .editor-controls-button.secondary-button:hover:enabled,\n.rk-admin .editor-controls-button.outline-button:hover:enabled {\n    color: var(--primary-hover);\n    border: 1px solid var(--primary-hover);\n    background: var(--highlight-blue);\n}\n\n.rk-admin .editor-controls-button.primary-button {\n    background: var(--primary);\n    border: 1px solid var(--primary);\n    color: #FFF;\n}\n\n.rk-admin .editor-controls-button.primary-button:disabled,\n.rk-admin .editor-controls-button.confirm-button:disabled {\n    cursor: not-allowed;\n    opacity: .6;\n}\n\n.rk-admin .editor-controls-button.primary-button:hover:enabled {\n    background: var(--primary-hover);\n    border: 1px solid var(--primary-hover);\n    color: #fff;\n}\n\n.rk-admin .editor-controls-button.indigo-button {\n    background: linear-gradient(135deg, var(--ce-indigo-55) 0%, var(--ce-indigo-40) 100%);\n    border: 1px solid transparent;\n    color: #fff;\n    box-shadow: 0 2px 8px rgba(102, 83, 240, 0.25);\n}\n\n.rk-admin .editor-controls-button.indigo-button:hover:enabled {\n    background: linear-gradient(135deg, #5847D8 0%, var(--ce-indigo-55) 100%);\n    border-color: transparent;\n    color: #fff;\n    box-shadow: 0 4px 14px rgba(102, 83, 240, 0.35);\n}\n\n.rk-admin .editor-controls-button.indigo-button:disabled {\n    cursor: not-allowed;\n    opacity: .6;\n}\n\n.rk-admin .editor-controls-button.add-button,\n.rk-admin .editor-controls-button.save-button {\n    background: var(--primary);\n    border: 1px solid var(--primary);\n    color: #FFF;\n}\n\n.rk-admin .editor-controls-button.add-button:hover:enabled,\n.rk-admin .editor-controls-button.save-button:hover:enabled {\n    background: var(--primary-hover);\n    border: 1px solid var(--primary-hover);\n}\n\n.rk-admin .editor-controls-button.confirm-button {\n    color: #fff;\n    border: 1px solid var(--primary);\n    background: var(--primary);\n}\n\n.rk-admin .editor-controls-button.confirm-button:hover:enabled {\n    color: #fff;\n    border: 1px solid var(--primary-hover);\n    background: var(--primary-hover);\n}\n\n.rk-admin .editor-controls-button.danger-button {\n    background: var(--red);\n    color: #FFF;\n}\n\n.rk-admin .editor-controls-button.danger-button:hover:enabled {\n    background: var(--red-hover);\n}\n\n.rk-admin .tertiary-button {\n    color: var(--blue);\n    background: #fff;\n    border: 1px solid var(--blue);\n}\n\n.rk-admin .admin-header {\n    padding-bottom: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    display: table;\n    width: calc(100% - 44px);\n}\n\n.rk-admin .items-list {\n    border: solid 1px #ddd;\n    border-radius: 2px;\n    margin: 10px 0;\n}\n\n.rk-admin .items-list .items-list-item {\n    border-top: solid 1px #ddd;\n    padding: 10px;\n    position: relative;\n    line-height: 1.3;\n    cursor: pointer;\n    min-height: 30px;\n}\n\n.rk-admin .items-list .items-list-item .items-list-item-content,\n.rk-admin .items-list .items-list-item .left-content {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.rk-admin .items-list .items-list-item .items-list-item-content.associated-projects {\n    justify-content: flex-start;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.rk-admin .items-list .items-list-item .fa-users,\n.rk-admin .items-list .items-list-item .fa-link {\n    font-size: 14px;\n    color: #28a745;\n    padding-right: 10px;\n}\n\n.rk-admin .items-list .items-list-item .item-name {\n    font-size: 16px;\n    word-break: break-word;\n}\n\n.rk-admin .items-list .items-list-item .item-description {\n    color: #666;\n    word-break: break-word;\n}\n\n.rk-admin .items-list .items-list-item .item-buttons {\n    top: 5px;\n    right: 10px;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.rk-admin .items-list .items-list-item .item-buttons button {\n    margin: 2px;\n    display: flex;\n}\n\n.rk-admin .items-list .items-list-item:first-child {\n    border-top: none;\n}\n\n.rk-admin .items-list .items-list-item:hover {\n    background-color: var(--background-2);\n}\n\n.rk-admin .items-list .items-list-item:hover .item-name {\n    color: var(--blue);\n}\n\n.rk-admin .items-list .items-list-item.synced-with-redcap:hover .item-name {\n    color: inherit;\n}\n\n.rk-admin .control-bar,\n.rk-admin .search-bar {\n    padding: var(--md_padding) calc(var(--lg_padding) - var(--target_spacing)) var(--md_padding) var(--lg_padding);\n    border-bottom: var(--border);\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.rk-admin .control-bar .control-bar-left {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    max-width: 100%;\n}\n\n.rk-admin .control-bar .control-bar-right {\n    float: right;\n}\n\n.rk-admin .selected-item-messages {\n    position: absolute;\n    right: 20px;\n    top: 10px;\n}\n\n.rk-admin .form-field {\n    position: relative;\n    border-bottom: solid 1px #eee;\n    padding-left: 180px;\n    padding-right: 38px;\n    padding-bottom: 10px;\n    padding-top: 10px;\n    min-height: 30px;\n}\n\n.rk-admin .form-field:last-of-type {\n    border-bottom: none;\n}\n\n.rk-admin .form-field>label .fa,\n.rk-admin .form-field>label i {\n    color: #bababa;\n}\n\n.rk-admin .form-field>label .fa:hover,\n.rk-admin .form-field>label i:hover {\n    color: #666;\n}\n\n\n.rk-admin .form-field.long-label {\n    padding-left: 260px;\n}\n\n.rk-admin .form-field .form-field-input .admin-input,\n.rk-admin .form-field .form-field-input .admin-textarea {\n    width: 100%;\n}\n\n.rk-admin .form-field .form-field-input .form-field-flex {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n}\n\n.rk-admin .form-field>label {\n    display: block;\n    width: 140px;\n    float: left;\n    position: absolute;\n    left: 20px;\n    top: 0;\n    line-height: 30px;\n    padding-top: 10px;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.rk-admin .form-field.long-label>label {\n    width: 230px;\n    text-overflow: ellipsis;\n    overflow: initial;\n    line-height: var(--default_line_height);\n}\n\n.rk-admin .form-field.last {\n    margin-bottom: 0;\n    border: none;\n    padding-bottom: 0;\n}\n\n.rk-admin .form-field .warning {\n    color: #666;\n}\n\n\n.rk-admin .form-field .field-notes {\n    color: var(--lightest_legible_grey);\n    margin-top: 5px;\n}\n\n.rk-admin .sub-field {\n    margin-top: 5px;\n    position: relative;\n}\n\n.rk-admin .sub-field label {\n    position: relative;\n    font-size: 12px;\n    font-weight: bold;\n    left: 0;\n    float: none;\n    display: block;\n}\n\n.rk-admin .form-field .sub-field label {\n    left: 0 !important;\n}\n\n.rk-admin .form-field.form-field-group-stacked {\n    padding-left: 0;\n    padding-right: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.rk-admin .form-field.form-field-group-stacked label {\n    position: relative;\n    line-height: 1.4;\n    width: auto;\n    padding-top: 0;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.rk-admin .checkbox-field label {\n    display: flex;\n    align-items: center;\n    margin-left: 5px;\n}\n\n.rk-admin .inline-form {\n    padding-left: 20px;\n    padding-right: 20px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.rk-admin .inline-form .error-message {\n    display: inline-block;\n    padding-left: 10px;\n    color: red;\n}\n\n.rk-admin .save-bar {\n    text-align: right;\n    padding-bottom: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    border-bottom: solid 1px #eee;\n}\n\n.rk-admin .master-table table {\n    width: 100%;\n    table-layout: fixed;\n}\n\n.rk-admin .master-table table th {\n    text-transform: uppercase;\n    font-size: 11px;\n    padding: 10px;\n    color: var(--lightest_legible_grey);\n}\n\n.rk-admin .master-table table td {\n    padding: 10px;\n    cursor: pointer;\n    color: #4c4c4c;\n    font-size: 12px;\n}\n\n.rk-admin .master-table table .label-cell,\n.rk-admin .master-table table .label-cell {\n    width: 173px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.rk-admin .master-table table span.stop-sign {\n    display: inline-block;\n    margin-right: 4px;\n    transform: rotate(90deg);\n    font-size: 16px;\n    position: relative;\n    top: 2px;\n    line-height: 12px;\n}\n\n.rk-admin .master-table table td.action-cell,\n.rk-admin .master-table table td.icon-button {\n    color: var(--icon-grey);\n}\n\n.rk-admin .master-table table td.action-cell {\n    width: 10px;\n    text-align: right;\n    cursor: pointer;\n}\n\n.rk-admin .master-table table .action-cell i {\n    cursor: pointer;\n}\n\n.rk-admin .master-table table td:hover {\n    color: var(--blue);\n}\n\n.rk-admin .master-table table td.action-cell:hover,\n.rk-admin .master-table table td.icon-button:hover {\n    color: var(--icon-grey-hover);\n}\n\n.rk-admin .master-table table td.action-cell .icon-image,\n.rk-admin .master-table table td.icon-button .icon-image {\n    height: 1em;\n    width: auto;\n    vertical-align: -0.125em;\n    filter: var(--icon-grey-filter);\n}\n\n.rk-admin .master-table table td.action-cell:hover .icon-image,\n.rk-admin .master-table table td.icon-button:hover .icon-image {\n    filter: var(--icon-grey-hover-filter);\n}\n\n.rk-admin .master-table table tr.selected td,\n.rk-admin .master-table table tr.selected:hover td {\n    background: var(--background-5);\n}\n\n.rk-admin .new-organization {\n    border-radius: var(--border_radius);\n    padding: 20px;\n}\n\n.rk-admin .new-organization .title {\n    line-height: 30px;\n    font-size: 21px;\n    padding-bottom: 5px;\n    font-weight: bold;\n}\n\n.rk-admin .new-organization .sub-title {\n    font-size: 14px;\n    color: #666666;\n}\n\n.rk-admin .settings {\n    padding-left: 20px;\n    padding-top: 20px;\n    padding-right: 20px;\n}\n\n.rk-admin .help {\n    color: #bababa;\n    font-size: 14px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    padding-left: 3px;\n}\n\n.rk-admin .help :hover {\n    color: #666666;\n}\n\n.rk-admin .help[aria-expanded=\"true\"] {\n    color: #666666;\n}\n\n.rk-admin .detail h2 {\n    height: auto;\n    line-height: 30px;\n    font-size: 30px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #d9d9d9;\n}\n\n.rk-admin input.ng-invalid.ng-touched {\n    border-color: red;\n    background-color: #ffeeee;\n}\n\n.rk-admin .error-message {\n    background-color: #ffeeee;\n    font-size: 14px;\n    display: inline-block;\n    padding-left: 5px;\n    padding-right: 5px;\n    line-height: 30px;\n    margin-left: 20px;\n}\n\n.rk-admin .error-message i {\n    color: red;\n    padding-right: 5px;\n}\n\n.rk-admin .section-header {\n    padding: 10px 20px 10px 20px;\n    line-height: 20px;\n}\n\n.rk-admin .section-header .section-header-title {\n    font-size: 16px;\n    padding-bottom: 10px;\n    padding-top: 10px;\n}\n\n.rk-admin .section-header p {\n    margin-bottom: 10px;\n}\n\n.rk-admin .section-select {\n    border: solid 1px #ddd;\n    margin-left: 20px;\n    width: 230px;\n    border-radius: var(--border_radius);\n    margin-top: 10px;\n    overflow: hidden;\n    box-sizing: border-box;\n}\n\n.rk-admin .section-select .section-select-title {\n    padding: 10px;\n    font-weight: bold;\n    background: #f2f2f2;\n}\n\n.rk-admin .section-select .section {\n    border-top: solid 1px #eee;\n}\n\n.rk-admin .section-select .section a {\n    display: block;\n    padding: 10px;\n    text-decoration: none;\n}\n\n.rk-admin .section-select .section a:hover,\n.rk-admin .section-select .section a.selected {\n    background: var(--selected);\n}\n\n.rk-admin .section-select .section a .fa {\n    width: 20px;\n}\n\n.rk-admin .no-items-indicator {\n    text-align: center;\n    line-height: 1.3;\n    margin: 0 auto;\n    padding: 10px 20px;\n}\n\n.rk-admin .no-items-indicator .no-items-title {\n    padding-top: 50px;\n    font-size: 40px;\n}\n\n.rk-admin .no-items-indicator .sso-required-title {\n    padding-top: 50px;\n    padding-bottom: 20px;\n    font-size: 40px;\n}\n\n.rk-admin .no-items-indicator .no-items-description {\n    padding-bottom: 20px;\n    font-size: 20px;\n}\n\n.rk-admin .no-items-indicator .sso-required-idp-link {\n    padding-bottom: 20px;\n    font-size: 20px;\n}\n\n.rk-admin .no-items-indicator .add-button {\n    color: var(--primary);\n    font-size: 30px;\n    cursor: pointer;\n}\n\n.rk-admin .no-items-indicator .add-button:hover {\n    color: var(--primary-hover);\n}\n\n.rk-admin .no-items-indicator .add-button .tippy-popover,\n.rk-admin .tippy-popover {\n    color: var(--lightest_legible_grey);\n    opacity: .7;\n    font-size: 14px;\n    height: var(--min_desktop_target);\n    width: var(--min_desktop_target);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: var(--transition);\n    cursor: pointer;\n}\n\n.rk-admin .no-items-indicator .add-button .tippy-popover:hover,\n.rk-admin .tippy-popover:hover {\n    color: var(--lightest_legible_grey);\n    opacity: 1;\n}\n\n.rk-admin .loader {\n    text-align: center;\n    padding: 20px;\n    font-size: 14px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.loading-indicator-small {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.rk-admin .feedback .stacked-form-field {\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.rk-admin .feedback .stacked-form-field.last {\n    border-top: 1px solid #d9d9d9;\n}\n\n.rk-admin .feedback label {\n    padding-top: 5px;\n    padding-bottom: 5px;\n    display: block;\n    font-weight: bold;\n    font-size: 18px;\n}\n\n.rk-admin .feedback input,\n.rk-admin .feedback textarea {\n    width: 600px;\n}\n\n.rk-admin .feedback textarea {\n    height: 200px;\n}\n\n.rk-admin .feedback .help {\n    color: #666666;\n    font-size: 14px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    width: 600px;\n}\n\n.rk-admin .minimal-table table {\n    width: 100%;\n}\n\n.rk-admin .minimal-table table .spacer {\n    width: 5px;\n}\n\n.rk-admin .minimal-table table .spacer-5 {\n    padding-left: 0;\n    padding-right: 0;\n    width: 5px;\n}\n\n.rk-admin .minimal-table table tr th,\n.rk-admin .minimal-table table tr td {\n    padding: 5px;\n    line-height: var(--default_line_height);\n    padding-bottom: 10px;\n    padding-top: 10px;\n}\n\n.rk-admin .minimal-table table tr td.button-cell {\n    padding-top: 5px;\n    padding-bottom: 5px;\n    position: relative;\n}\n\n.rk-admin .minimal-table table tr th {\n    font-size: 11px;\n    vertical-align: bottom;\n    border-bottom: var(--border);\n    text-transform: uppercase;\n}\n\n.rk-admin .minimal-table table tr td {\n    border-bottom: var(--border);\n    vertical-align: top;\n}\n\n.rk-admin .minimal-table table tbody tr.alternating {\n    background: var(--background-2);\n}\n\n.rk-admin .minimal-pagination-bar-wrapper {\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    height: 41px;\n    box-sizing: border-box;\n    text-align: center;\n}\n\n.rk-admin .minimal-pagination-bar-wrapper .minimal-pagination-bar {\n    display: inline-block;\n    border: solid 1px #ddd;\n    background: var(--ce-grey-5);\n    padding: 5px;\n    border-radius: var(--border_radius) var(--border_radius) 0px 0px;\n    border-bottom: none;\n}\n\n.rk-admin .minimal-pagination-bar-wrapper .minimal-pagination-bar .editor-controls-button {\n    background: #fff;\n}\n\n.rk-admin .user-items-wrapper {\n    margin-top: 5px;\n}\n\n.rk-admin .user-item {\n    padding-left: 5px;\n    padding-right: 5px;\n    border: solid 1px #ddd;\n    background: #f2f2f2;\n    border-radius: 2px;\n    margin-right: 5px;\n    float: left;\n    clear: both;\n    margin-bottom: 5px;\n}\n\n.rk-admin .user-project-institutions,\n.rk-admin .user-items-wrapper {\n    clear: both;\n    padding-bottom: 10px;\n}\n\n.rk-admin .user-item a {\n    color: #666;\n}\n\n.rk-admin .project-settings-section-text {\n    line-height: 18px;\n}\n\n.rk-admin .admin-table .team-name {\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.rk-admin .study-permissions {\n    margin-bottom: 10px;\n}\n\n.rk-admin .study-permissions:last-of-type {\n    margin-bottom: 0;\n}\n\n.rk-admin .study-permissions .study-name {\n    font-weight: bold;\n}\n\n.rk-admin .rk-studio-dropdown {\n    position: absolute;\n    left: 10px;\n    top: 50px;\n    border: solid 1px #d9d9d9;\n    border-radius: 2px;\n    background: #FFF;\n    box-shadow: var(--box-shadow-2);\n    width: 700px;\n    z-index: 1;\n}\n\n.rk-admin .rk-studio-dropdown.rk-studio-popup {\n    top: -250px;\n}\n\n.rk-admin .rk-studio-dropdown .dropdown-header {\n    border-bottom: solid 1px #e5e5e5;\n    background: #f9f9f9;\n    line-height: 20px;\n}\n\n.rk-admin .rk-studio-dropdown .dropdown-header .dropdown-header-text {\n    padding: 10px;\n    font-weight: bold;\n}\n\n.rk-admin .rk-studio-dropdown .dropdown-header table {\n    width: 100%;\n}\n\n\n.rk-admin .rk-studio-dropdown .dropdown-header table tr td {\n    text-align: left;\n    padding: var(--md_padding);\n    text-transform: uppercase;\n    font-size: 11px;\n    line-height: 10px;\n    font-weight: bold;\n}\n\n.rk-admin .rk-studio-dropdown table tr td {\n    text-align: left;\n    padding: 10px;\n    font-size: 12px;\n    line-height: 16px;\n}\n\n.rk-admin .rk-studio-dropdown .dropdown-content-box {\n    max-height: 250px;\n    overflow: auto;\n}\n\n.rk-admin .rk-studio-dropdown .dropdown-content table {\n    width: 100%;\n}\n\n.rk-admin .rk-studio-dropdown .dropdown-content table tr {\n    border-bottom: solid 1px #e5e5e5;\n    cursor: pointer;\n}\n\n.rk-admin .rk-studio-dropdown .dropdown-content table tr:hover {\n    color: var(--blue);\n    background: var(--background-2);\n}\n\n.rk-admin .rk-studio-dropdown .dropdown-content table tr.selected {\n    background: var(--selected);\n}\n\n.rk-admin .rk-studio-dropdown .dropdown-content .validation-error {\n    padding: 10px;\n    border-bottom: solid 1px #e5e5e5;\n}\n\n.rk-admin .service-account-key {\n    display: block;\n    padding-left: 5px;\n    padding-right: 20px;\n    border: solid 1px #ddd;\n    background: #f2f2f2;\n    border-radius: 2px;\n    margin-right: 5px;\n    color: #666;\n    position: relative;\n    margin-bottom: 5px;\n}\n\n.rk-admin .service-account-key .key-id {\n    font-weight: bold;\n}\n\n.rk-admin .service-account-key .fa-trash {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    cursor: pointer;\n}\n\n.rk-admin .service-account-key:last-child {\n    margin-bottom: 0;\n}\n\n.rk-admin .panel-tabs {\n    border-bottom: solid 1px var(--border_color);\n    display: flex;\n    padding: 0 10px;\n    position: sticky;\n    top: 0;\n    background: #FFF;\n    z-index: 2;\n}\n\n.rk-admin .panel-tabs .panel-tab {\n    float: left;\n    padding-left: 10px;\n    padding-right: 10px;\n    line-height: 30px;\n    cursor: pointer;\n    font-size: 11px;\n    color: var(--lightest_legible_grey);\n}\n\n.rk-admin .panel-tabs .panel-tab:hover {\n    color: var(--blue);\n}\n\n.rk-admin .panel-tabs .panel-tab.selected,\n.rk-admin .panel-tabs .panel-tab.selected.highlight {\n    background: #FFF;\n    color: var(--default_text_color);\n    border-bottom: var(--tab_active_secondary);\n}\n\n.rk-admin .panel-tabs .panel-tab.selected {\n    cursor: default;\n}\n\n.rk-admin .panel-tabs .panel-tab.highlight {\n    color: var(--blue);\n}\n\n.rk-admin .form-item-list {\n    width: 100%;\n    margin-bottom: 12px;\n}\n\n.rk-admin .form-item-editor {\n    border-top: solid 1px #d9d9d9;\n    background: white;\n}\n\n.rk-admin .form-item-editor.ui-sortable-helper {\n    display: table;\n}\n\n.rk-admin .form-item-editor.last-form-item {\n    border-bottom: solid 1px #d9d9d9;\n}\n\n.rk-admin .form-item-editor .drag-handle {\n    vertical-align: top;\n    min-width: 20px;\n    height: var(--min_desktop_target);\n    display: flex;\n    align-items: center;\n    cursor: move;\n}\n\n.rk-admin .form-item-editor .form-item-title {\n    line-height: 1.2;\n    position: relative;\n    display: flex;\n    flex: 1;\n}\n\n.rk-admin .form-item-editor .form-item-title .fa,\n.rk-admin .form-item-editor .form-item-title .icon-image-button,\n.rk-admin .action-bar .add-form-item-button {\n    padding: 0;\n    height: var(--min_desktop_target);\n    width: var(--min_desktop_target);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.rk-admin .form-item-editor .form-item-title .fa.expand-icon {\n    width: var(--md_padding);\n    color: var(--blue);\n    justify-content: flex-start;\n}\n\n.rk-admin .form-item-editor .form-item-title .action-bar {\n    display: flex;\n    position: relative;\n}\n\n.rk-admin .form-item-editor .form-item-editor-content {\n    width: 100%;\n}\n\n.rk-admin .form-item-editor .form-item-title a {\n    text-decoration: none;\n    min-height: var(--min_desktop_target);\n    padding: 3px 0;\n    display: flex;\n    align-items: center;\n    flex: 1;\n}\n\n.rk-admin .form-item-editor .form-item-title:hover a,\n.rk-admin .form-item-editor .form-item-title:hover .fa.expand-icon {\n    color: var(--blue-hover);\n}\n\n.rk-admin .form-item-editor .form-item-main {\n    background: var(--ce-grey-3);\n    padding-top: 8px;\n}\n\n.rk-admin .action-bar {\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.rk-admin .action-bar i {\n    padding: 10px 10px 0 0;\n    color: var(--icon-grey);\n    line-height: 20px;\n}\n\n.rk-admin .action-bar .spacer {\n    display: inline-block;\n    width: 7px;\n    padding: 10px 10px 0 0;\n}\n\n.rk-admin .action-bar i:hover {\n    color: var(--icon-grey-hover);\n}\n\n.rk-admin .action-bar i {\n    cursor: pointer;\n}\n\n.rk-admin .action-bar .icon-image-button {\n    /* match the sibling \".action-bar i\" line box so the trash SVG aligns with the caret/arrow font-icons */\n    padding: 10px 10px 0 0;\n    line-height: 20px;\n    cursor: pointer;\n}\n\n.rk-admin .action-bar .icon-image-button .icon-image {\n    /* 0.85em (not 1em): a tight-viewBox SVG fills its whole box, so it must be\n       smaller than 1em to visually match the padded caret/arrow/copy font-glyphs beside it */\n    height: 0.85em;\n    width: auto;\n    vertical-align: middle;\n    filter: var(--icon-grey-filter);\n}\n\n.rk-admin .action-bar .icon-image-button:hover .icon-image {\n    filter: var(--icon-grey-hover-filter);\n}\n\n.rk-admin .step-checkbox-field {\n    padding: 5px 10px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: var(--sm_padding);\n}\n\n.rk-admin .step-checkbox-field label {\n    font-weight: bold;\n    font-size: 11px;\n    color: #4c4c4c;\n    display: inline-block;\n    margin-left: 5px;\n    padding: 0;\n}\n\n.rk-admin .editor-form-field label .help {\n    font-size: 11px;\n    padding: 0;\n    padding-left: 3px;\n}\n\n.rk-admin .editor-form-field .step-checkbox-field label {\n    display: inline-block;\n    margin-left: 5px;\n    padding: 0;\n}\n\n.rk-admin .preview-notification {\n    margin: 0px auto;\n    width: 700px;\n    position: relative;\n    margin-top: 30px;\n    margin-bottom: 30px;\n    z-index: 5001;\n    border-radius: 5px;\n    overflow: hidden;\n    background: #FFF;\n}\n\n.rk-admin .qr-code-parent {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.rk-admin .qr-code-child {\n    padding: 8px;\n}\n\n.rk-admin .trust-button {\n    padding: 20px;\n}\n\n.rk-admin .redcap-instrument-description {\n    font-style: italic;\n    font-size: 0.8em;\n}\n\n.rk-admin .mobile_only {\n    display: none;\n}\n\n.rk-admin .restricted-indicator {\n    font-size: .6em;\n    position: relative;\n    top: -10px;\n    width: 5px;\n    margin: 0;\n    padding: 0;\n}\n\n@media screen and (min-width: 768px) {\n    .rk-admin .new-organization {\n        margin: 5px 20px;\n        border: none;\n    }\n}\n\n@media screen and (max-width: 768px) {\n\n    /* form elements */\n    .rk-admin .admin-input,\n    .rk-admin .admin-select,\n    .rk-admin .image-upload,\n    .control-bar .admin-input,\n    .control-bar .admin-select,\n    .rk-admin .editor-controls-button {\n        width: auto;\n        min-height: var(--min_touch_target);\n        min-width: var(--min_touch_target);\n        margin-bottom: var(--target_spacing);\n        margin-right: var(--target_spacing);\n    }\n\n    .rk-admin .admin-input[type=\"checkbox\"] {\n        min-width: 20px !important;\n        min-height: 20px !important;\n        width: 20px !important;\n        height: 20px !important;\n    }\n\n    .rk-admin button,\n    .rk-admin .button {\n        min-height: var(--min_touch_target);\n        min-width: var(--min_touch_target);\n        display: flex;\n        align-items: center;\n    }\n\n    .rk-admin .admin-select {\n        height: var(--min_touch_target);\n        margin-left: 0;\n        /* fixes issue specific to ios chrome, but not desktop chrome or safari */\n    }\n\n    .rk-admin .image-upload {\n        display: flex !important;\n        align-items: center;\n    }\n\n    .rk-admin .editor-controls-button {\n        display: flex;\n        align-items: center;\n    }\n\n    .rk-admin .form-field {\n        padding-left: 0;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .rk-admin .form-field.long-label {\n        display: flex;\n        flex-direction: column;\n        padding-left: 0;\n        padding: 10px 0;\n        margin: 0 10px;\n        border-bottom: var(--border);\n    }\n\n    .rk-admin .admin-input {\n        width: auto;\n    }\n\n    .rk-admin .form-field.long-label .form-field-input {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n    }\n\n    .form-field-input {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .form-field-input span {\n        display: flex;\n        align-items: center;\n    }\n\n    .rk-admin .form-field.long-label .form-field-input>* {\n        margin-right: 5px;\n    }\n\n    .rk-admin .form-field.long-label .form-field-input>*:last-child {\n        margin-right: 0;\n    }\n\n    .rk-admin .form-field>label {\n        position: relative;\n        left: 0;\n        font-size: inherit;\n        padding-bottom: 5px;\n        padding-top: 0;\n        line-height: initial;\n    }\n\n    .rk-admin .form-field .field-notes {\n        word-break: break-word;\n        margin: 3px 0;\n    }\n\n    /* layout */\n    .rk-admin .items-list {\n        margin: 0;\n    }\n\n    .rk-admin .control-bar,\n    .rk-admin .search-bar {\n        padding: var(--md_padding) var(--md_padding) calc(var(--md_padding) - var(--target_spacing)) var(--md_padding);\n    }\n\n    .rk-admin .control-bar .control-bar-right {\n        width: 100%;\n    }\n\n    .rk-admin .rk-studio-dropdown {\n        max-width: calc(100% - 10px);\n        left: 5px;\n    }\n\n    .rk-admin .mobile_only {\n        display: flex;\n        align-items: center;\n    }\n\n    .rk-admin .hide_on_mobile {\n        display: none !important;\n    }\n\n    .rk-admin .minimal-pagination-bar-wrapper .minimal-pagination-bar {\n        display: flex;\n        margin: 0 auto;\n        align-items: center;\n        justify-content: space-between;\n        max-width: 300px;\n        position: relative;\n        left: 0;\n    }\n}\n\n/* Accordion (TODO: begin refactoring this and other components from this file into separate files in a shared folder) */\n\n.rk-admin .accordion {\n    border: var(--border);\n    border-radius: var(--border_radius);\n    box-shadow: var(--box-shadow);\n    margin-bottom: var(--sm_padding);\n}\n\n.rk-admin .accordion-header {\n    display: flex;\n    cursor: pointer;\n    flex-direction: row;\n    align-items: center;\n    padding: var(--md_padding);\n    width: 100%;\n}\n\n.rk-admin .accordion-header svg {\n    min-width: 20px;\n    padding-right: inherit;\n}\n\n.rk-admin .accordion-title {\n    margin-top: 0;\n    font-weight: 500;\n}\n\n.rk-admin .accordion-content {\n    padding: 0 var(--md_padding) var(--sm_padding) var(--md_padding);\n}\n\n.rk-admin .accordion-content h3 {\n    border-top: var(--border);\n    padding-top: var(--md_padding);\n}\n\n@media screen and (min-width: 768px) {\n    .rk-admin .accordion-content {\n        padding: 0 var(--lg_padding) var(--md_padding) var(--lg_padding);\n    }\n}\n\n/* SVG ICONS */\n.rk-admin .master-table table th.icon-button,\n.rk-admin .master-table table td.icon-button,\n.rk-admin .icon-button {\n    min-height: var(--min_desktop_target);\n    width: var(--min_desktop_target);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px;\n    cursor: pointer;\n}\n\n.rk-admin .icon-image {\n    padding: 0;\n    width: 12px;\n    min-height: 10px;\n    filter: var(--lightest-legible-grey-filter);\n}\n\n.rk-admin .icon-button:hover .icon-image {\n    filter: var(--blue-filter);\n}\n\n.rk-admin .editor-controls-button .icon-image {\n    margin-right: 4px;\n}\n\n.rk-admin .editor-controls-button.confirm-button .icon-image,\n.rk-admin .editor-controls-button.primary-button .icon-image {\n    filter: var(--white-filter);\n}\n\n.rk-admin .editor-controls-button.open .icon-image,\n.rk-admin .editor-controls-button.secondary-button .icon-image {\n    filter: var(--blue-filter);\n}\n\n.rk-admin .icon-button .icon-image {\n    margin-right: 0;\n}\n\n@media screen and (max-width: 768px) {\n    .rk-admin .icon-button {\n        height: var(--min_touch_target);\n        width: var(--min_touch_target);\n    }\n}\n\n\n/* Pagination */\n\n.rk-admin .pagination-bar-wrapper {\n    box-sizing: border-box;\n    text-align: center;\n    font-size: var(--text_sm);\n    font-weight: normal;\n    display: flex;\n    justify-content: flex-end;\n    /* eliminates jump on page load: */\n    min-height: 42px;\n}\n\n.rk-admin .pagination-bar span {\n    padding: 0 5px;\n    white-space: nowrap;\n}\n\n.rk-admin .pagination-bar-wrapper .pagination-bar {\n    display: flex;\n    align-items: center;\n    padding: var(--sm_padding) calc(var(--sm_padding) - var(--target_spacing)) calc(var(--sm_padding) - var(--target_spacing)) var(--sm_padding);\n}\n\n.rk-admin .pagination-bar .pagination-nav {\n    display: flex;\n    align-items: center;\n    border-left: var(--border);\n    padding-left: 10px;\n    margin-left: 10px;\n}\n.rk-admin .pagination-bar .pagination-nav .admin-input {\n    border: var(--border);\n}\n.rk-admin .pagination-bar-wrapper .pagination-bar .editor-controls-button {\n    padding: 0;\n    display: flex;\n    margin: 0;\n}\n\n.rk-admin .pagination-bar .icon-image {\n    width: 11px;\n    margin-right: 0;\n}\n\n.rk-admin .pagination-bar .fa-angle-right,\n.rk-admin .pagination-bar .fa-angle-left {\n    font-size: 16px;\n}\n\n.rk-admin .pagination-bar .icon-image.vertical-bar {\n    height: 18px;\n    transform: rotate(90deg);\n    width: 14px;\n    margin: 0 -4px;\n    opacity: .8;\n}\n\n.rk-admin .pagination-bar-wrapper .pagination-bar .editor-controls-button:disabled {\n    display: none;\n}\n\n.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input {\n    padding: 2px 5px;\n    height: 28px;\n    min-height: 28px;\n    line-height: 22px;\n    text-align: center;\n    border-radius: var(--border_radius);\n    outline: none;\n    transition: none;\n    margin: 0 0 0 1px;\n}\n\n.rk-admin .pagination-bar-wrapper .admin-input,\n.rk-admin .pagination-bar-wrapper .pagination-nav .editor-controls-button {\n    border: 1px solid transparent;\n    background-color: transparent;\n}\n\n.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input:hover,\n.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input:active,\n.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input:focus,\n.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input:focus-visible,\n.rk-admin .pagination-bar-wrapper .pagination-bar .admin-input:focus-within {\n    border-radius: var(--border_radius);\n    border-color: transparent;\n    outline: 1px solid var(--highlight-border);\n    outline-offset: -2px;\n    background-color: #fff;\n}\n\n.rk-admin .pagination-bar-wrapper .pagination-bar .editor-controls-button:hover {\n    background: var(--ce-grey-4);\n}\n\n.rk-admin .pagination-bar-wrapper.bottom-pagination.fixed {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-top: var(--border);\n    background: var(--ce-grey-1);\n}\n\n@media screen and (max-width: 768px) {\n    .rk-admin .pagination-bar-wrapper .pagination-bar {\n        display: flex;\n        margin: 0 auto;\n        align-items: center;\n        justify-content: space-between;\n        max-width: 300px;\n        position: relative;\n        left: 0;\n    }\n\n    .rk-admin .pagination-bar-wrapper.bottom-pagination {\n        position: sticky;\n        bottom: 0;\n        margin: 0;\n        background: var(--ce-grey-2);\n        border-top: var(--border);\n        border-radius: 0;\n    }\n\n    .rk-admin .pagination-bar-wrapper .pagination-bar span,\n    .rk-admin .pagination-bar-wrapper .pagination-bar .admin-input,\n    .rk-admin .pagination-bar-wrapper .pagination-bar .editor-controls-button {\n        margin-bottom: var(--target_spacing);\n    }\n\n}\n\n/* helper classes */\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n}\n\n/* overrides the server-injected \"Signing out...\" spinner globally across the admin */\n.careev-modal-spinner .loading-indicator-container {\n    background-color: transparent;\n    box-shadow: none;\n    border-radius: 0;\n    width: auto;\n    padding: 0;\n    top: 50%;\n    transform: translateY(-50%);\n}\n.careev-modal-spinner .loading-indicator .loading-medium {\n    font-size: clamp(16px, 2.5vw, 28px) !important;\n    background-color: var(--ce-grey-70);\n    border-radius: 0.8em;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n    backdrop-filter: blur(4px);\n    padding: 1.2em 2.4em;\n    width: auto;\n    max-width: 100%;\n    min-width: auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.6em;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.careev-modal-spinner .loading-indicator .loading-medium span {\n    color: white;\n    font-size: 1em;\n    opacity: 0.9;\n    font-weight: 400;\n    letter-spacing: 0.01em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
